import { GraphQLClient } from 'graphql-request';
import { RequestInit } from 'graphql-request/dist/types.dom';
import { useQuery, useMutation, UseQueryOptions, UseMutationOptions } from '@tanstack/react-query';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };

function fetcher<TData, TVariables extends { [key: string]: any }>(client: GraphQLClient, query: string, variables?: TVariables, requestHeaders?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request({
    document: query,
    variables,
    requestHeaders
  });
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Any: { input: any; output: any; }
  AnyAggridInput: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  Json: { input: any; output: any; }
};

export type AccessPermission = {
  __typename?: 'AccessPermission';
  cancel: Scalars['Boolean']['output'];
  create: Scalars['Boolean']['output'];
  delete: Scalars['Boolean']['output'];
  update: Scalars['Boolean']['output'];
  view: Scalars['Boolean']['output'];
  view_self: Scalars['Boolean']['output'];
};

export type AccessPermissionInput = {
  cancel: Scalars['Boolean']['input'];
  create: Scalars['Boolean']['input'];
  delete: Scalars['Boolean']['input'];
  update: Scalars['Boolean']['input'];
  view: Scalars['Boolean']['input'];
  view_self: Scalars['Boolean']['input'];
};

export type ActivityLog = {
  __typename?: 'ActivityLog';
  activity_detail?: Maybe<ActivityLogDetailObject>;
  activity_type?: Maybe<ActivityType>;
  created_by?: Maybe<CreatorObject>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  document_type?: Maybe<ActivityLogDocumentType>;
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  reference_id?: Maybe<Scalars['Int']['output']>;
};

export type ActivityLogByRefereceIdInput = {
  document_type: ActivityLogDocumentType;
  reference_id: Scalars['Int']['input'];
};

export type ActivityLogCopyObject = {
  __typename?: 'ActivityLogCopyObject';
  id?: Maybe<Scalars['Int']['output']>;
  unique_id?: Maybe<Scalars['String']['output']>;
};

export type ActivityLogCopyObjectInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityLogCreateInput = {
  activity_detail: ActivityLogDetailObjectInput;
  activity_type: ActivityType;
  created_by: CreatorInputObject;
  document_type: ActivityLogDocumentType;
  reference_id: Scalars['Int']['input'];
};

export type ActivityLogDetailObject = {
  __typename?: 'ActivityLogDetailObject';
  added_related_employee?: Maybe<ActivityLogRelatedEmployeeObject>;
  attachment_list?: Maybe<Array<Scalars['String']['output']>>;
  copied_from?: Maybe<ActivityLogCopyObject>;
  copied_to?: Maybe<ActivityLogCopyObject>;
  curr_status?: Maybe<Scalars['String']['output']>;
  deleted_related_employee?: Maybe<ActivityLogRelatedEmployeeObject>;
  message?: Maybe<Array<Scalars['String']['output']>>;
  prev_status?: Maybe<Scalars['String']['output']>;
  updated_fields?: Maybe<Scalars['Json']['output']>;
};

export type ActivityLogDetailObjectInput = {
  added_related_employee?: InputMaybe<ActivityLogRelatedEmployeeObjectInput>;
  attachment_list?: InputMaybe<Array<Scalars['String']['input']>>;
  copied_from?: InputMaybe<ActivityLogCopyObjectInput>;
  copied_to?: InputMaybe<ActivityLogCopyObjectInput>;
  curr_status?: InputMaybe<Scalars['String']['input']>;
  deleted_related_employee?: InputMaybe<ActivityLogRelatedEmployeeObjectInput>;
  message?: InputMaybe<Array<Scalars['String']['input']>>;
  prev_status?: InputMaybe<Scalars['String']['input']>;
  secondary_operation?: InputMaybe<ActivityType>;
  updated_fields?: InputMaybe<Scalars['Json']['input']>;
};

export enum ActivityLogDocumentType {
  CashSales = 'cash_sales',
  CreditNote = 'credit_note',
  Customer = 'customer',
  CustomerDeposit = 'customer_deposit',
  DeliveryOrder = 'delivery_order',
  GoodsAdjustment = 'goods_adjustment',
  GoodsIssue = 'goods_issue',
  GoodsReceive = 'goods_receive',
  GoodsReturn = 'goods_return',
  GoodsTransfer = 'goods_transfer',
  Item = 'item',
  Promotion = 'promotion',
  PurchaseInvoice = 'purchase_invoice',
  PurchaseOrder = 'purchase_order',
  PurchaseRequest = 'purchase_request',
  PurchaseReturn = 'purchase_return',
  Quotation = 'quotation',
  Role = 'role',
  SalesInvoice = 'sales_invoice',
  SalesOrder = 'sales_order',
  SalesReturn = 'sales_return',
  User = 'user',
  Vendor = 'vendor'
}

export type ActivityLogFindManyAggrid = {
  __typename?: 'ActivityLogFindManyAggrid';
  count: Scalars['Int']['output'];
  results: Array<ActivityLog>;
};

export type ActivityLogRelatedEmployeeObject = {
  __typename?: 'ActivityLogRelatedEmployeeObject';
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  user_unique_id?: Maybe<Scalars['String']['output']>;
};

export type ActivityLogRelatedEmployeeObjectInput = {
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  user_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityLogUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export enum ActivityType {
  AddRelatedEmployee = 'add_related_employee',
  Approve = 'approve',
  Cancel = 'cancel',
  CancelPendingScan = 'cancel_pending_scan',
  Comment = 'comment',
  Copy = 'copy',
  Create = 'create',
  Delete = 'delete',
  DeleteRelatedEmployee = 'delete_related_employee',
  Document = 'document',
  Edit = 'edit',
  Image = 'image',
  StatusChange = 'status_change'
}

export enum AdditionalDiscountType {
  Baht = 'baht',
  Percent = 'percent',
  Promotion = 'promotion'
}

export enum AggridArrayFilterType {
  Array = 'array'
}

export type AggridBooleanFilterModelInput = {
  filter?: InputMaybe<Scalars['String']['input']>;
  filterType?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AggridBooleanFilterModelType>;
};

export enum AggridBooleanFilterModelType {
  Equals = 'equals',
  NotEqual = 'notEqual'
}

export type AggridDateFilterModelInput = {
  filter?: InputMaybe<Scalars['String']['input']>;
  filterTo?: InputMaybe<Scalars['String']['input']>;
  filterType?: InputMaybe<AggridDateFilterType>;
  type?: InputMaybe<AggridDateFilterModelType>;
};

export enum AggridDateFilterModelType {
  Blank = 'blank',
  Empty = 'empty',
  Equals = 'equals',
  GreaterThan = 'greaterThan',
  GreaterThanOrEqual = 'greaterThanOrEqual',
  InRange = 'inRange',
  LessThan = 'lessThan',
  LessThanOrEqual = 'lessThanOrEqual',
  NotBlank = 'notBlank',
  NotEqual = 'notEqual'
}

export enum AggridDateFilterType {
  Date = 'date'
}

export type AggridFloatFilterModelInput = {
  condition1?: InputMaybe<AggridFloatFilterModelInputCondition>;
  condition2?: InputMaybe<AggridFloatFilterModelInputCondition>;
  filter?: InputMaybe<Scalars['Float']['input']>;
  filterTo?: InputMaybe<Scalars['Float']['input']>;
  filterType?: InputMaybe<AggridNumberFilterType>;
  operator?: InputMaybe<AggridOperatorFilter>;
  type?: InputMaybe<AggridNumberFilterModelType>;
};

export type AggridFloatFilterModelInputCondition = {
  filter?: InputMaybe<Scalars['Float']['input']>;
  filterTo?: InputMaybe<Scalars['Float']['input']>;
  filterType?: InputMaybe<AggridNumberFilterType>;
  type?: InputMaybe<AggridNumberFilterModelType>;
};

export type AggridGenericArrayFilterModelInput = {
  filterType?: InputMaybe<AggridArrayFilterType>;
  type?: InputMaybe<AggridGenericArrayFilterModelType>;
  values?: InputMaybe<Scalars['Any']['input']>;
};

export enum AggridGenericArrayFilterModelType {
  Equals = 'equals',
  Has = 'has',
  HasEvery = 'hasEvery',
  HasSome = 'hasSome',
  IsEmpty = 'isEmpty'
}

export enum AggridISimpleFilterModelType {
  Blank = 'blank',
  Contains = 'contains',
  Empty = 'empty',
  EndsWith = 'endsWith',
  Equals = 'equals',
  GreaterThan = 'greaterThan',
  GreaterThanOrEqual = 'greaterThanOrEqual',
  InRange = 'inRange',
  LessThan = 'lessThan',
  LessThanOrEqual = 'lessThanOrEqual',
  NotBlank = 'notBlank',
  NotContains = 'notContains',
  NotEqual = 'notEqual',
  StartsWith = 'startsWith'
}

export type AggridIntFilterModelInput = {
  condition1?: InputMaybe<AggridIntFilterModelInputCondition>;
  condition2?: InputMaybe<AggridIntFilterModelInputCondition>;
  filter?: InputMaybe<Scalars['Int']['input']>;
  filterTo?: InputMaybe<Scalars['Int']['input']>;
  filterType?: InputMaybe<AggridNumberFilterType>;
  operator?: InputMaybe<AggridOperatorFilter>;
  type?: InputMaybe<AggridNumberFilterModelType>;
};

export type AggridIntFilterModelInputCondition = {
  filter?: InputMaybe<Scalars['Int']['input']>;
  filterTo?: InputMaybe<Scalars['Int']['input']>;
  filterType?: InputMaybe<AggridNumberFilterType>;
  type?: InputMaybe<AggridNumberFilterModelType>;
};

export enum AggridNumberFilterModelType {
  Blank = 'blank',
  Empty = 'empty',
  Equals = 'equals',
  GreaterThan = 'greaterThan',
  GreaterThanOrEqual = 'greaterThanOrEqual',
  InRange = 'inRange',
  LessThan = 'lessThan',
  LessThanOrEqual = 'lessThanOrEqual',
  NotBlank = 'notBlank',
  NotEqual = 'notEqual'
}

export enum AggridNumberFilterType {
  Number = 'number'
}

export enum AggridObjectArrayFilterModelType {
  Every = 'every',
  None = 'none',
  Some = 'some'
}

export enum AggridObjectArrayFilterType {
  ObjectArray = 'objectArray'
}

export enum AggridOperatorFilter {
  And = 'AND',
  Or = 'OR'
}

export type AggridSetSingleFilterModelInput = {
  condition1?: InputMaybe<AggridSetSingleFilterModelInputCondition>;
  condition2?: InputMaybe<AggridSetSingleFilterModelInputCondition>;
  filterType?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<AggridOperatorFilter>;
  values?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
};

export type AggridSetSingleFilterModelInputCondition = {
  filterType?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AggridSetSingleFilterModelType>;
  values?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
};

export enum AggridSetSingleFilterModelType {
  Blank = 'blank',
  Contains = 'contains',
  Equals = 'equals',
  NotBlank = 'notBlank',
  NotContains = 'notContains',
  NotEqual = 'notEqual'
}

export type AggridSortModelItem = {
  colId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortOrder>;
};

export type AggridSortModelItemInput = {
  colId: Scalars['String']['input'];
  sort: SortOrder;
};

export type AggridStringFilterModelInput = {
  condition1?: InputMaybe<AggridStringFilterModelInputCondition>;
  condition2?: InputMaybe<AggridStringFilterModelInputCondition>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterTo?: InputMaybe<Scalars['String']['input']>;
  filterType?: InputMaybe<AggridTextFilterType>;
  mode?: InputMaybe<AggridStringModeOption>;
  operator?: InputMaybe<AggridOperatorFilter>;
  type?: InputMaybe<AggridStringFilterModelType>;
};

export type AggridStringFilterModelInputCondition = {
  filter?: InputMaybe<Scalars['String']['input']>;
  filterTo?: InputMaybe<Scalars['String']['input']>;
  filterType?: InputMaybe<AggridTextFilterType>;
  mode?: InputMaybe<AggridStringModeOption>;
  type?: InputMaybe<AggridStringFilterModelType>;
};

export enum AggridStringFilterModelType {
  Blank = 'blank',
  Contains = 'contains',
  Empty = 'empty',
  EndsWith = 'endsWith',
  Equals = 'equals',
  NotBlank = 'notBlank',
  NotContains = 'notContains',
  NotEqual = 'notEqual',
  StartsWith = 'startsWith'
}

export enum AggridStringModeOption {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type AggridTemplateInput = {
  endRow?: InputMaybe<Scalars['Int']['input']>;
  filterModel?: InputMaybe<Scalars['Any']['input']>;
  sortModel?: InputMaybe<Array<AggridSortModelItemInput>>;
  startRow?: InputMaybe<Scalars['Int']['input']>;
};

export enum AggridTextFilterType {
  Text = 'text'
}

export type ApprovalProgress = {
  __typename?: 'ApprovalProgress';
  approval_template?: Maybe<ApprovalTemplate>;
  approval_template_id: Scalars['Int']['output'];
  approver: User;
  approver_id: Scalars['Int']['output'];
  created_date: Scalars['DateTime']['output'];
  document_id: Scalars['Int']['output'];
  document_type: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  step_number: Scalars['Int']['output'];
  updated_date?: Maybe<Scalars['DateTime']['output']>;
};

export type ApprovalTemplate = {
  __typename?: 'ApprovalTemplate';
  approver_id_list?: Maybe<Array<Scalars['String']['output']>>;
  approver_list?: Maybe<Array<User>>;
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  required_approval: Scalars['Int']['output'];
  step_number: Scalars['Int']['output'];
  workflow_document_type: Scalars['String']['output'];
  workflow_step_number: Scalars['Int']['output'];
  workflow_template?: Maybe<WorkflowTemplate>;
};

export enum AvailableFor {
  Erp = 'erp',
  ErpPos = 'erp_pos'
}

export type BinLocation = {
  __typename?: 'BinLocation';
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  warehouse_level_3: WarehouseLevel3;
};

export type Branch = {
  __typename?: 'Branch';
  address: Scalars['Json']['output'];
  created_date?: Maybe<Scalars['DateTime']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_hq: Scalars['Boolean']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  short_name: Scalars['String']['output'];
  status: Scalars['Int']['output'];
  unique_id: Scalars['String']['output'];
  user_id_list: Array<Scalars['Int']['output']>;
  user_list?: Maybe<Array<Maybe<BranchUser>>>;
  zone?: Maybe<Scalars['String']['output']>;
};

export type BranchUser = {
  __typename?: 'BranchUser';
  branch?: Maybe<Branch>;
  branch_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type BundleItemDetail = {
  __typename?: 'BundleItemDetail';
  bundle_item: Item;
  bundle_item_id: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  item: Item;
  item_sku_detail?: Maybe<ItemSkuDetail>;
  item_unique_id: Scalars['String']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  qty: Scalars['Int']['output'];
  ratio_percentage?: Maybe<Scalars['Float']['output']>;
  sku_desc?: Maybe<Scalars['String']['output']>;
  sku_name: Scalars['String']['output'];
  sorting_order?: Maybe<Scalars['Int']['output']>;
  special_price?: Maybe<Scalars['Float']['output']>;
};

export type CashSales = {
  __typename?: 'CashSales';
  account_id?: Maybe<Scalars['String']['output']>;
  additional_discount?: Maybe<Scalars['Float']['output']>;
  additional_discount_type?: Maybe<AdditionalDiscountType>;
  aggrid_status?: Maybe<Scalars['String']['output']>;
  approval_step?: Maybe<Scalars['Int']['output']>;
  approver_list?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  branch: Branch;
  branch_id: Scalars['Int']['output'];
  contact_person_list?: Maybe<Array<Scalars['Json']['output']>>;
  created_by: Scalars['Json']['output'];
  created_date: Scalars['DateTime']['output'];
  credit_day?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customer_details?: Maybe<Scalars['Json']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  deduction_document_list?: Maybe<Array<SalesDeduction>>;
  deduction_total_amount?: Maybe<Scalars['Float']['output']>;
  delivery_date?: Maybe<Scalars['DateTime']['output']>;
  due_date?: Maybe<Scalars['DateTime']['output']>;
  external_reference_no?: Maybe<Scalars['String']['output']>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  is_original_print?: Maybe<Scalars['Json']['output']>;
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_list?: Maybe<Array<SalesItem>>;
  item_price_list?: Maybe<ItemPriceList>;
  item_price_list_id?: Maybe<Scalars['Int']['output']>;
  last_updated_by?: Maybe<Scalars['Json']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  need_tax_invoice?: Maybe<Scalars['Boolean']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  paid_net_amount?: Maybe<Scalars['Float']['output']>;
  paid_total_amount?: Maybe<Scalars['Float']['output']>;
  payment_list?: Maybe<Array<SalesPayment>>;
  payment_total_amount?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_vat_type?: Maybe<PriceVatType>;
  promotion_list?: Maybe<Array<PromotionAppliedLog>>;
  reference_document_list?: Maybe<Array<Scalars['Json']['output']>>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['Json']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  reviewer_list?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  sales_channel?: Maybe<SalesChannel>;
  sales_channel_id?: Maybe<Scalars['Int']['output']>;
  sales_contact?: Maybe<Array<Scalars['Json']['output']>>;
  sales_type?: Maybe<Scalars['String']['output']>;
  shipping_cost?: Maybe<Scalars['Float']['output']>;
  sub_status?: Maybe<Scalars['String']['output']>;
  tag_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  tag_list?: Maybe<Array<Tag>>;
  tax_invoice_date?: Maybe<Scalars['DateTime']['output']>;
  tax_invoice_no?: Maybe<Scalars['String']['output']>;
  template_remark_id?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
};

export enum CouponType {
  ManyTime = 'many_time',
  OneTime = 'one_time'
}

export type CreatorInputObject = {
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  img_url?: InputMaybe<Array<Scalars['String']['input']>>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  user_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type CreatorObject = {
  __typename?: 'CreatorObject';
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  img_url?: Maybe<Array<Scalars['String']['output']>>;
  last_name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
  user_unique_id?: Maybe<Scalars['String']['output']>;
};

export type CustomerDeposit = {
  __typename?: 'CustomerDeposit';
  additional_discount?: Maybe<Scalars['Float']['output']>;
  additional_discount_type?: Maybe<AdditionalDiscountType>;
  aggrid_status?: Maybe<Scalars['String']['output']>;
  branch?: Maybe<Branch>;
  branch_id: Scalars['Int']['output'];
  contact_person_list?: Maybe<Array<Scalars['Json']['output']>>;
  created_by: Scalars['Json']['output'];
  created_date: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  customer_details?: Maybe<Scalars['Json']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  deposit_list?: Maybe<Array<CustomerDepositItem>>;
  due_date: Scalars['DateTime']['output'];
  external_reference_no?: Maybe<Scalars['String']['output']>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  is_original_print?: Maybe<Scalars['Json']['output']>;
  issue_date: Scalars['DateTime']['output'];
  last_updated_by?: Maybe<Scalars['Json']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  need_tax_invoice?: Maybe<Scalars['Boolean']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  paid_net_amount?: Maybe<Scalars['Float']['output']>;
  paid_total_amount?: Maybe<Scalars['Float']['output']>;
  payment_list?: Maybe<Array<SalesPayment>>;
  payment_total_amount?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_vat_type?: Maybe<PriceVatType>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['Json']['output']>>;
  remaining_deposit_amount?: Maybe<Scalars['Float']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  sub_status?: Maybe<Scalars['String']['output']>;
  tag_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  tag_list?: Maybe<Array<Tag>>;
  tax_invoice_date?: Maybe<Scalars['DateTime']['output']>;
  tax_invoice_no?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
};

export type CustomerDepositItem = {
  __typename?: 'CustomerDepositItem';
  customer_deposit?: Maybe<CustomerDeposit>;
  customer_deposit_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  reference_document_id?: Maybe<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  vat_percentage?: Maybe<Scalars['String']['output']>;
  withholding_tax_type?: Maybe<Scalars['String']['output']>;
  withholding_tax_value?: Maybe<Scalars['Float']['output']>;
};

export enum CustomerEligibility {
  All = 'all',
  SpecificCustomers = 'specific_customers',
  SpecificGroups = 'specific_groups'
}

export type DeliveryAttribute = {
  __typename?: 'DeliveryAttribute';
  height?: Maybe<Scalars['Float']['output']>;
  height_uom?: Maybe<Unit>;
  height_uom_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  item: Item;
  item_id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  length_uom?: Maybe<Unit>;
  length_uom_id?: Maybe<Scalars['Int']['output']>;
  thick?: Maybe<Scalars['Float']['output']>;
  thick_uom?: Maybe<Unit>;
  thick_uom_id?: Maybe<Scalars['Int']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
  volume_uom?: Maybe<Unit>;
  volume_uom_id?: Maybe<Scalars['Int']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  weight_uom?: Maybe<Unit>;
  weight_uom_id?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  width_uom?: Maybe<Unit>;
  width_uom_id?: Maybe<Scalars['Int']['output']>;
};

export type DeliveryOrder = {
  __typename?: 'DeliveryOrder';
  aggrid_status?: Maybe<Scalars['String']['output']>;
  branch: Branch;
  branch_id: Scalars['Int']['output'];
  created_by?: Maybe<CreatorObject>;
  created_date: Scalars['DateTime']['output'];
  customer_details?: Maybe<Scalars['Json']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  delivery_date?: Maybe<Scalars['DateTime']['output']>;
  delivery_detail?: Maybe<Scalars['Json']['output']>;
  delivery_type?: Maybe<Scalars['String']['output']>;
  destination_warehouse?: Maybe<Warehouse>;
  destination_warehouse_id?: Maybe<Scalars['Int']['output']>;
  exported_date?: Maybe<Scalars['DateTime']['output']>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  last_updated_by?: Maybe<CreatorObject>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  reference_document_list?: Maybe<Array<ReferenceSalesDocument>>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['Json']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  sub_status?: Maybe<Scalars['String']['output']>;
  tag_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  tag_list?: Maybe<Array<Tag>>;
  template_remark_id?: Maybe<Scalars['String']['output']>;
  trace_entry_list: Array<TraceEntry>;
  trace_entry_unique_id_list: Array<Scalars['String']['output']>;
  tracking_no?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
};

export type ExportGenerateInput = {
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  export_type: PurchaseExportType;
  params?: InputMaybe<Scalars['Json']['input']>;
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
  user_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export enum GenderType {
  Female = 'female',
  Male = 'male'
}

export enum InventoryDocumentType {
  GoodsAdjust = 'goods_adjust',
  GoodsIssue = 'goods_issue',
  GoodsReceive = 'goods_receive',
  GoodsReturn = 'goods_return',
  GoodsTransfer = 'goods_transfer'
}

export type InventoryReferenceLineItem = {
  __typename?: 'InventoryReferenceLineItem';
  line_item_document_type: Scalars['String']['output'];
  line_item_unique_id: Scalars['String']['output'];
};

export type InventoryReferenceLineItemInput = {
  line_item_document_type: Scalars['String']['input'];
  line_item_unique_id: Scalars['String']['input'];
};

export type Item = {
  __typename?: 'Item';
  attribute_list: Array<Scalars['Json']['output']>;
  barcode: Scalars['String']['output'];
  brand?: Maybe<Scalars['String']['output']>;
  bundle_item_detail_list: Array<BundleItemDetail>;
  category_group?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['Json']['output']>;
  created_date: Scalars['DateTime']['output'];
  customer_insurance_duration?: Maybe<Scalars['Int']['output']>;
  deliver_uom?: Maybe<Unit>;
  deliver_uom_id?: Maybe<Scalars['Int']['output']>;
  delivery_attribute?: Maybe<DeliveryAttribute>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  img_url: Array<Scalars['String']['output']>;
  inactive_date?: Maybe<Scalars['DateTime']['output']>;
  insurance_detail?: Maybe<Scalars['String']['output']>;
  insurance_name?: Maybe<Scalars['String']['output']>;
  is_active: Scalars['Int']['output'];
  is_purchasable?: Maybe<Scalars['Boolean']['output']>;
  is_saleable?: Maybe<Scalars['Boolean']['output']>;
  is_stockable?: Maybe<Scalars['Boolean']['output']>;
  item_variant_key_list: Array<ItemVariantKey>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_category?: Maybe<Scalars['String']['output']>;
  max_stock_qty?: Maybe<Scalars['Float']['output']>;
  min_purchase_request_qty?: Maybe<Scalars['Int']['output']>;
  min_stock_qty?: Maybe<Scalars['Float']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pre_sale?: Maybe<Scalars['Boolean']['output']>;
  purchase_standard_price?: Maybe<Scalars['Float']['output']>;
  purchase_uom?: Maybe<Unit>;
  purchase_uom_id?: Maybe<Scalars['Int']['output']>;
  purchase_vat_type?: Maybe<Scalars['String']['output']>;
  remark_status?: Maybe<Scalars['String']['output']>;
  reorder_point?: Maybe<Scalars['Float']['output']>;
  replenishment_stock?: Maybe<Scalars['Boolean']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_vat_type?: Maybe<Scalars['String']['output']>;
  sales_uom?: Maybe<Unit>;
  sales_uom_id?: Maybe<Scalars['Int']['output']>;
  segment?: Maybe<Scalars['String']['output']>;
  seller_insurance_duration?: Maybe<Scalars['Int']['output']>;
  seller_unique_id: Scalars['String']['output'];
  selling_point_list: Array<Scalars['Json']['output']>;
  series?: Maybe<Scalars['String']['output']>;
  set_attribute?: Maybe<Scalars['Json']['output']>;
  sku_detail_list: Array<ItemSkuDetail>;
  sku_list: Array<ItemSkuValue>;
  special_price?: Maybe<Scalars['Float']['output']>;
  stock_uom?: Maybe<Unit>;
  stock_uom_id?: Maybe<Scalars['Int']['output']>;
  sub_category?: Maybe<Scalars['String']['output']>;
  tag_id_list: Array<Scalars['Int']['output']>;
  tag_list: Array<Tag>;
  tracability?: Maybe<Tracability>;
  type?: Maybe<ItemType>;
  unique_id: Scalars['String']['output'];
  uom_group?: Maybe<UomGroup>;
  uom_group_id?: Maybe<Scalars['Int']['output']>;
  vendor_contact?: Maybe<Scalars['Json']['output']>;
};

export type ItemAdjustment = {
  __typename?: 'ItemAdjustment';
  adjusted_price?: Maybe<Scalars['Float']['output']>;
  current_price?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  item_name: Scalars['String']['output'];
  item_price_list?: Maybe<ItemPriceList>;
  item_price_list_id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  reference_unique_id?: Maybe<Scalars['String']['output']>;
  sku_name: Scalars['String']['output'];
};

export type ItemDeleteOutput = {
  __typename?: 'ItemDeleteOutput';
  active_document_list?: Maybe<Array<Scalars['String']['output']>>;
  is_deletable?: Maybe<Scalars['Boolean']['output']>;
  item?: Maybe<Item>;
};

export type ItemPriceList = {
  __typename?: 'ItemPriceList';
  adjusted_item_list?: Maybe<Array<Maybe<ItemAdjustment>>>;
  adjusted_price?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  is_active: Scalars['Int']['output'];
  is_increase: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  sales_channel?: Maybe<SalesChannel>;
  sales_channel_id?: Maybe<Scalars['Int']['output']>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  type: Scalars['String']['output'];
  unique_id: Scalars['String']['output'];
};

export type ItemSkuDetail = {
  __typename?: 'ItemSkuDetail';
  available_qty?: Maybe<Scalars['Int']['output']>;
  barcode?: Maybe<Scalars['String']['output']>;
  bundle_item_detail_list: Array<BundleItemDetail>;
  id: Scalars['Int']['output'];
  img_url: Array<Scalars['String']['output']>;
  item: Item;
  item_sku: ItemSkuValue;
  item_sku_qty?: Maybe<Array<ItemSkuQty>>;
  item_unique_id: Scalars['String']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  purchase_ordered_qty?: Maybe<Scalars['Int']['output']>;
  purchase_standard_price?: Maybe<Scalars['Float']['output']>;
  sale_committed_qty?: Maybe<Scalars['Int']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sku_name: Scalars['String']['output'];
  special_price?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  stock_qty?: Maybe<Scalars['Int']['output']>;
  total_sku_qty?: Maybe<Scalars['Json']['output']>;
};

export type ItemSkuQty = {
  __typename?: 'ItemSkuQty';
  available_qty: Scalars['Int']['output'];
  barcode: Scalars['String']['output'];
  bin_id?: Maybe<Scalars['Int']['output']>;
  bin_location?: Maybe<BinLocation>;
  bin_name?: Maybe<Scalars['String']['output']>;
  expired_date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  item_sku_detail?: Maybe<ItemSkuDetail>;
  item_unique_id?: Maybe<Scalars['String']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  lot_date?: Maybe<Scalars['DateTime']['output']>;
  manufactured_date?: Maybe<Scalars['DateTime']['output']>;
  purchase_ordered_qty: Scalars['Int']['output'];
  sale_committed_qty: Scalars['Int']['output'];
  serial_no?: Maybe<Scalars['String']['output']>;
  sku_name: Scalars['String']['output'];
  stock_qty: Scalars['Int']['output'];
  transit_qty: Scalars['Int']['output'];
  warehouse?: Maybe<Warehouse>;
  warehouse_id?: Maybe<Scalars['Int']['output']>;
};

export enum ItemSkuQtyScalarFieldEnum {
  BinId = 'bin_id',
  Id = 'id',
  SkuName = 'sku_name',
  WarehouseId = 'warehouse_id'
}

export type ItemSkuValue = {
  __typename?: 'ItemSkuValue';
  id: Scalars['Int']['output'];
  item?: Maybe<Item>;
  item_unique_id?: Maybe<Scalars['String']['output']>;
  item_variant_value: Array<ItemVariantValue>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  sku_detail?: Maybe<ItemSkuDetail>;
  sku_name: Scalars['String']['output'];
  variant_key_id: Scalars['Int']['output'];
  variant_value_id: Scalars['Int']['output'];
};

export enum ItemType {
  Bundle = 'bundle',
  Normal = 'normal',
  Service = 'service',
  Variant = 'variant'
}

export type ItemVariantKey = {
  __typename?: 'ItemVariantKey';
  id: Scalars['Int']['output'];
  item: Item;
  item_unique_id: Scalars['String']['output'];
  item_variant_value_list: Array<ItemVariantValue>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  variant_key_name: Scalars['String']['output'];
};

export type ItemVariantValue = {
  __typename?: 'ItemVariantValue';
  id: Scalars['Int']['output'];
  item_sku: Array<ItemSkuValue>;
  item_unique_id: Scalars['String']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  variant_key: ItemVariantKey;
  variant_key_name: Scalars['String']['output'];
  variant_value_name: Scalars['String']['output'];
};

export enum MarketingModelType {
  PromotionSetting = 'promotion_setting'
}

export type Mutation = {
  __typename?: 'Mutation';
  PurchaseOrderCreate: PurchaseOrder;
  PurchaseOrderDelete: PurchaseOrder;
  PurchaseOrderUpdate: PurchaseOrder;
  PurchaseRequestCreate: PurchaseRequest;
  PurchaseRequestDelete: PurchaseRequest;
  PurchaseRequestUpdate: PurchaseRequest;
  PurchaseReturnCreate: PurchaseReturn;
  PurchaseReturnDelete: PurchaseReturn;
  PurchaseReturnUpdate: PurchaseReturn;
};


export type MutationPurchaseOrderCreateArgs = {
  input: PurchaseOrderCreateInput;
};


export type MutationPurchaseOrderDeleteArgs = {
  uniqueInput: PurchaseOrderUniqueInput;
};


export type MutationPurchaseOrderUpdateArgs = {
  input: PurchaseOrderUpdateInput;
  uniqueInput: PurchaseOrderUniqueInput;
};


export type MutationPurchaseRequestCreateArgs = {
  input: PurchaseRequestCreateInput;
};


export type MutationPurchaseRequestDeleteArgs = {
  uniqueInput: PurchaseRequestUniqueInput;
};


export type MutationPurchaseRequestUpdateArgs = {
  input: PurchaseRequestUpdateInput;
  uniqueInput: PurchaseRequestUniqueInput;
};


export type MutationPurchaseReturnCreateArgs = {
  input: PurchaseReturnCreateInput;
};


export type MutationPurchaseReturnDeleteArgs = {
  uniqueInput: PurchaseReturnUniqueInput;
};


export type MutationPurchaseReturnUpdateArgs = {
  input: PurchaseReturnUpdateInput;
  uniqueInput: PurchaseReturnUniqueInput;
};

export enum PriceVatType {
  ExcludeVat = 'exclude_vat',
  IncludeVat = 'include_vat'
}

export type PromotionAppliedLog = {
  __typename?: 'PromotionAppliedLog';
  cash_sales?: Maybe<CashSales>;
  cash_sales_id?: Maybe<Scalars['Int']['output']>;
  conditional_item_id_list: Array<Scalars['Int']['output']>;
  coupon_code: Scalars['String']['output'];
  discount_rate?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  promotion_id: Scalars['Int']['output'];
  promotion_unique_id?: Maybe<Scalars['String']['output']>;
  receive_type?: Maybe<ReceiveType>;
  redeem_item_list: Array<Scalars['Json']['output']>;
  total_discount_amount?: Maybe<Scalars['Decimal']['output']>;
};

export type PromotionAppliedLogUpsertInput = {
  conditional_item_id_list: Array<Scalars['Int']['input']>;
  coupon_code: Scalars['String']['input'];
  discount_rate?: InputMaybe<Scalars['Decimal']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  promotion_id: Scalars['Int']['input'];
  promotion_unique_id?: InputMaybe<Scalars['String']['input']>;
  receive_type?: InputMaybe<ReceiveType>;
  redeem_item_list: Array<Scalars['Json']['input']>;
  total_discount_amount?: InputMaybe<Scalars['Decimal']['input']>;
};

export enum PromotionCategory {
  DiscountFixPrice = 'discount_fix_price',
  DiscountOrder = 'discount_order',
  DiscountProduct = 'discount_product',
  FreeGift = 'free_gift'
}

export enum PromotionStatus {
  Active = 'active',
  Inactive = 'inactive'
}

export enum PromotionType {
  AllPromotions = 'all_promotions',
  SingleCategoryPromotion = 'single_category_promotion',
  SinglePromotion = 'single_promotion'
}

export enum PurchaseCondition {
  AllItems = 'all_items',
  SpecificItems = 'specific_items'
}

export enum PurchaseDocumentType {
  PurchaseOrder = 'purchase_order',
  PurchaseRequest = 'purchase_request',
  PurchaseReturn = 'purchase_return'
}

export enum PurchaseExportType {
  PurchaseOrder = 'purchase_order',
  PurchaseOrderByBranch = 'purchase_order_by_branch',
  PurchaseOrderByItem = 'purchase_order_by_item',
  PurchaseOrderByVendor = 'purchase_order_by_vendor',
  PurchaseRequest = 'purchase_request',
  PurchaseReturn = 'purchase_return'
}

export type PurchaseItem = {
  __typename?: 'PurchaseItem';
  barcode: Scalars['String']['output'];
  discount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  item_img_url?: Maybe<Array<Scalars['String']['output']>>;
  item_name: Scalars['String']['output'];
  item_sku_desc?: Maybe<Scalars['String']['output']>;
  item_sku_name: Scalars['String']['output'];
  item_unique_id: Scalars['String']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  po_qty?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_per_unit?: Maybe<Scalars['Float']['output']>;
  qty: Scalars['Float']['output'];
  qty_issued?: Maybe<Scalars['Float']['output']>;
  qty_ordered?: Maybe<Scalars['Float']['output']>;
  qty_received?: Maybe<Scalars['Float']['output']>;
  reference_document_type: PurchaseDocumentType;
  reference_line_item?: Maybe<ReferencePurchaseLineItem>;
  reference_unique_id: Scalars['String']['output'];
  remark?: Maybe<Scalars['String']['output']>;
  stock_qty?: Maybe<Scalars['Float']['output']>;
  tracability: TraceAbilityEnum;
  unique_id: Scalars['String']['output'];
  uom_id: Scalars['Int']['output'];
  uom_name: Scalars['String']['output'];
  vat_percentage?: Maybe<Scalars['String']['output']>;
  withholding_tax_type?: Maybe<Scalars['String']['output']>;
  withholding_tax_value?: Maybe<Scalars['Float']['output']>;
};

export type PurchaseItemCreateInput = {
  barcode: Scalars['String']['input'];
  discount?: InputMaybe<Scalars['Float']['input']>;
  item_img_url?: InputMaybe<Array<Scalars['String']['input']>>;
  item_name: Scalars['String']['input'];
  item_sku_desc?: InputMaybe<Scalars['String']['input']>;
  item_sku_name: Scalars['String']['input'];
  item_unique_id: Scalars['String']['input'];
  po_qty?: InputMaybe<Scalars['Float']['input']>;
  pre_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  price_per_unit?: InputMaybe<Scalars['Float']['input']>;
  qty: Scalars['Float']['input'];
  qty_issued?: InputMaybe<Scalars['Float']['input']>;
  qty_ordered?: InputMaybe<Scalars['Float']['input']>;
  qty_received?: InputMaybe<Scalars['Float']['input']>;
  reference_document_type: PurchaseDocumentType;
  reference_line_item?: InputMaybe<ReferencePurchaseLineItemInput>;
  reference_unique_id: Scalars['String']['input'];
  remark?: InputMaybe<Scalars['String']['input']>;
  stock_qty?: InputMaybe<Scalars['Float']['input']>;
  tracability: TraceAbilityEnum;
  unique_id: Scalars['String']['input'];
  uom_id: Scalars['Int']['input'];
  uom_name: Scalars['String']['input'];
  vat_percentage?: InputMaybe<Scalars['String']['input']>;
  withholding_tax_type?: InputMaybe<Scalars['String']['input']>;
  withholding_tax_value?: InputMaybe<Scalars['Float']['input']>;
};

export type PurchaseItemFindManyByLineItemInput = {
  line_item_document_type: Scalars['String']['input'];
  line_item_document_unique_id?: InputMaybe<Scalars['String']['input']>;
  line_item_unique_id: Scalars['String']['input'];
};

export type PurchaseItemFindManyInput = {
  reference_document_type?: InputMaybe<PurchaseDocumentType>;
  reference_line_item?: InputMaybe<PurchaseItemFindManyByLineItemInput>;
  reference_unique_id?: InputMaybe<Scalars['String']['input']>;
  unique_id_list?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PurchaseItemUpsertInput = {
  barcode: Scalars['String']['input'];
  discount?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  item_img_url?: InputMaybe<Array<Scalars['String']['input']>>;
  item_name: Scalars['String']['input'];
  item_sku_desc?: InputMaybe<Scalars['String']['input']>;
  item_sku_name: Scalars['String']['input'];
  item_unique_id: Scalars['String']['input'];
  po_qty?: InputMaybe<Scalars['Float']['input']>;
  pre_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  price_per_unit?: InputMaybe<Scalars['Float']['input']>;
  qty: Scalars['Float']['input'];
  qty_issued?: InputMaybe<Scalars['Float']['input']>;
  qty_ordered?: InputMaybe<Scalars['Float']['input']>;
  qty_received?: InputMaybe<Scalars['Float']['input']>;
  reference_document_type: PurchaseDocumentType;
  reference_line_item?: InputMaybe<ReferencePurchaseLineItemInput>;
  reference_unique_id: Scalars['String']['input'];
  remark?: InputMaybe<Scalars['String']['input']>;
  stock_qty?: InputMaybe<Scalars['Float']['input']>;
  tracability: TraceAbilityEnum;
  unique_id: Scalars['String']['input'];
  uom_id: Scalars['Int']['input'];
  uom_name: Scalars['String']['input'];
  vat_percentage?: InputMaybe<Scalars['String']['input']>;
  withholding_tax_type?: InputMaybe<Scalars['String']['input']>;
  withholding_tax_value?: InputMaybe<Scalars['Float']['input']>;
};

export enum PurchaseModelType {
  PurchaseOrder = 'purchase_order',
  PurchaseRequest = 'purchase_request',
  PurchaseReturn = 'purchase_return'
}

export type PurchaseOrder = {
  __typename?: 'PurchaseOrder';
  additional_discount?: Maybe<Scalars['Float']['output']>;
  additional_discount_type?: Maybe<AdditionalDiscountType>;
  aggrid_status?: Maybe<Scalars['String']['output']>;
  approval_step?: Maybe<Scalars['Int']['output']>;
  approver_list?: Maybe<Array<Scalars['Json']['output']>>;
  branch: Branch;
  branch_id: Scalars['Int']['output'];
  created_by?: Maybe<CreatorObject>;
  created_date: Scalars['DateTime']['output'];
  credit_day?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currency_display_name?: Maybe<Scalars['String']['output']>;
  delivery_address?: Maybe<Scalars['Json']['output']>;
  destination_warehouse?: Maybe<Warehouse>;
  destination_warehouse_id?: Maybe<Scalars['Int']['output']>;
  exchange_rate?: Maybe<Scalars['Float']['output']>;
  expected_date?: Maybe<Scalars['DateTime']['output']>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_list?: Maybe<Array<PurchaseItem>>;
  last_updated_by?: Maybe<CreatorObject>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_vat_type?: Maybe<PriceVatType>;
  reference_document_id?: Maybe<Scalars['String']['output']>;
  reference_document_list?: Maybe<Array<PurchaseReferenceDocument>>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['Json']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  reviewer_list?: Maybe<Array<Scalars['Json']['output']>>;
  sub_status?: Maybe<Scalars['String']['output']>;
  tag_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  tag_list?: Maybe<Array<Tag>>;
  template_remark_id?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  vendor_details?: Maybe<Scalars['Json']['output']>;
  vendor_unique_id?: Maybe<Scalars['String']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
  within_date?: Maybe<Scalars['DateTime']['output']>;
};

export type PurchaseOrderAggridOutput = {
  __typename?: 'PurchaseOrderAggridOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<PurchaseOrder>;
};

export type PurchaseOrderByBranchExportView = {
  __typename?: 'PurchaseOrderByBranchExportView';
  branch_id: Scalars['String']['output'];
  branch_name?: Maybe<Scalars['String']['output']>;
  item_additional_discount?: Maybe<Scalars['Float']['output']>;
  item_discount?: Maybe<Scalars['Float']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  item_pre_discount_amount?: Maybe<Scalars['Float']['output']>;
  item_unique_id?: Maybe<Scalars['String']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  uom_name?: Maybe<Scalars['String']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
};

export type PurchaseOrderByBranchExportViewAggirdOutput = {
  __typename?: 'PurchaseOrderByBranchExportViewAggirdOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<PurchaseOrderByBranchExportView>;
};

export type PurchaseOrderByItemExportView = {
  __typename?: 'PurchaseOrderByItemExportView';
  item_additional_discount?: Maybe<Scalars['Float']['output']>;
  item_discount?: Maybe<Scalars['Float']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  item_net_amount?: Maybe<Scalars['Float']['output']>;
  item_pre_discount_amount?: Maybe<Scalars['Float']['output']>;
  item_pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  item_unique_id?: Maybe<Scalars['String']['output']>;
  item_vat_amount?: Maybe<Scalars['Float']['output']>;
  qty?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  uom_name?: Maybe<Scalars['String']['output']>;
};

export type PurchaseOrderByItemExportViewAggirdOutput = {
  __typename?: 'PurchaseOrderByItemExportViewAggirdOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<PurchaseOrderByItemExportView>;
};

export type PurchaseOrderByVendorExportView = {
  __typename?: 'PurchaseOrderByVendorExportView';
  additional_discount?: Maybe<Scalars['Float']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  pre_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  total_document?: Maybe<Scalars['Int']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vendor_id: Scalars['String']['output'];
  vendor_name?: Maybe<Scalars['String']['output']>;
};

export type PurchaseOrderByVendorExportViewAggirdOutput = {
  __typename?: 'PurchaseOrderByVendorExportViewAggirdOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<PurchaseOrderByVendorExportView>;
};

export type PurchaseOrderCreateInput = {
  additional_discount?: InputMaybe<Scalars['Float']['input']>;
  additional_discount_type?: InputMaybe<AdditionalDiscountType>;
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  approval_step?: InputMaybe<Scalars['Int']['input']>;
  approver_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  branch_id: Scalars['Int']['input'];
  created_by?: InputMaybe<CreatorInputObject>;
  credit_day?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currency_display_name?: InputMaybe<Scalars['String']['input']>;
  delivery_address?: InputMaybe<Scalars['Json']['input']>;
  destination_warehouse_id?: InputMaybe<Scalars['Int']['input']>;
  exchange_rate?: InputMaybe<Scalars['Float']['input']>;
  expected_date?: InputMaybe<Scalars['DateTime']['input']>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  issue_date?: InputMaybe<Scalars['DateTime']['input']>;
  item_list?: InputMaybe<Array<PurchaseItemCreateInput>>;
  main_status?: InputMaybe<Scalars['String']['input']>;
  net_amount?: InputMaybe<Scalars['Float']['input']>;
  post_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  price_vat_type?: InputMaybe<PriceVatType>;
  reference_document_id?: InputMaybe<Scalars['String']['input']>;
  reference_document_list?: InputMaybe<Array<PurchaseReferenceDocumentInput>>;
  reference_no?: InputMaybe<Scalars['String']['input']>;
  related_user_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  remark?: InputMaybe<Scalars['String']['input']>;
  reviewer_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  tag_id_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  template_remark_id?: InputMaybe<Scalars['String']['input']>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  unique_id: Scalars['String']['input'];
  vat_0_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_7_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_exempted_amount?: InputMaybe<Scalars['Float']['input']>;
  vendor_details?: InputMaybe<Scalars['Json']['input']>;
  vendor_unique_id?: InputMaybe<Scalars['String']['input']>;
  withholding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  within_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PurchaseOrderUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseOrderUpdateInput = {
  additional_discount?: InputMaybe<Scalars['Float']['input']>;
  additional_discount_type?: InputMaybe<AdditionalDiscountType>;
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  approval_step?: InputMaybe<Scalars['Int']['input']>;
  approver_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  branch_id: Scalars['Int']['input'];
  credit_day?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currency_display_name?: InputMaybe<Scalars['String']['input']>;
  delivery_address?: InputMaybe<Scalars['Json']['input']>;
  destination_warehouse_id?: InputMaybe<Scalars['Int']['input']>;
  exchange_rate?: InputMaybe<Scalars['Float']['input']>;
  expected_date?: InputMaybe<Scalars['DateTime']['input']>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  issue_date?: InputMaybe<Scalars['DateTime']['input']>;
  item_list?: InputMaybe<Array<PurchaseItemUpsertInput>>;
  last_updated_by?: InputMaybe<CreatorInputObject>;
  main_status?: InputMaybe<Scalars['String']['input']>;
  net_amount?: InputMaybe<Scalars['Float']['input']>;
  post_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  price_vat_type?: InputMaybe<PriceVatType>;
  reference_document_id?: InputMaybe<Scalars['String']['input']>;
  reference_document_list?: InputMaybe<Array<PurchaseReferenceDocumentInput>>;
  reference_no?: InputMaybe<Scalars['String']['input']>;
  related_user_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  remark?: InputMaybe<Scalars['String']['input']>;
  reviewer_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  tag_id_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  template_remark_id?: InputMaybe<Scalars['String']['input']>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
  vat_0_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_7_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_exempted_amount?: InputMaybe<Scalars['Float']['input']>;
  vendor_details?: InputMaybe<Scalars['Json']['input']>;
  vendor_unique_id?: InputMaybe<Scalars['String']['input']>;
  withholding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  within_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PurchaseOrderView = {
  __typename?: 'PurchaseOrderView';
  branch_id?: Maybe<Scalars['Int']['output']>;
  branch_name?: Maybe<Scalars['String']['output']>;
  branch_unique_id?: Maybe<Scalars['String']['output']>;
  branch_unique_id_name?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_by_object?: Maybe<Scalars['Json']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  destination_warehouse_id?: Maybe<Scalars['Int']['output']>;
  destination_warehouse_name?: Maybe<Scalars['String']['output']>;
  destination_warehouse_unique_id?: Maybe<Scalars['String']['output']>;
  expected_date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_list?: Maybe<Array<PurchaseItem>>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  reference_document_list?: Maybe<Array<Scalars['String']['output']>>;
  reference_document_object_list?: Maybe<Array<Scalars['Json']['output']>>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['String']['output']>>;
  related_user_object_list?: Maybe<Array<Scalars['Json']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
  vendor_name?: Maybe<Scalars['String']['output']>;
  vendor_unique_id?: Maybe<Scalars['String']['output']>;
  within_date?: Maybe<Scalars['DateTime']['output']>;
};

export type PurchaseOrderViewAggridOutput = {
  __typename?: 'PurchaseOrderViewAggridOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<PurchaseOrderView>;
};

export type PurchaseReferenceDocument = {
  __typename?: 'PurchaseReferenceDocument';
  document_id?: Maybe<Scalars['Int']['output']>;
  document_type?: Maybe<PurchaseReferenceType>;
  document_unique_id?: Maybe<Scalars['String']['output']>;
};

export type PurchaseReferenceDocumentInput = {
  document_id?: InputMaybe<Scalars['Int']['input']>;
  document_type?: InputMaybe<PurchaseReferenceType>;
  document_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export enum PurchaseReferenceType {
  PurchaseOrder = 'purchase_order',
  PurchaseRequest = 'purchase_request',
  PurchaseReturn = 'purchase_return',
  SalesOrder = 'sales_order'
}

export type PurchaseRequest = {
  __typename?: 'PurchaseRequest';
  accepted_remark?: Maybe<Scalars['String']['output']>;
  aggrid_status?: Maybe<Scalars['String']['output']>;
  approval_step?: Maybe<Scalars['Int']['output']>;
  approver_list?: Maybe<Array<Scalars['Json']['output']>>;
  attachment_list?: Maybe<Array<Scalars['Json']['output']>>;
  branch: Branch;
  branch_id: Scalars['Int']['output'];
  created_by?: Maybe<CreatorObject>;
  created_date: Scalars['DateTime']['output'];
  delivery_address?: Maybe<Scalars['Json']['output']>;
  expected_date?: Maybe<Scalars['DateTime']['output']>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_list?: Maybe<Array<PurchaseItem>>;
  last_updated_by?: Maybe<CreatorObject>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  reference_document_list?: Maybe<Array<PurchaseReferenceDocument>>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['Json']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  requester?: Maybe<Scalars['Json']['output']>;
  reviewer_list?: Maybe<Array<Scalars['Json']['output']>>;
  sub_status?: Maybe<Scalars['String']['output']>;
  tag_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  tag_list?: Maybe<Array<Tag>>;
  template_remark_id?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
  within_date?: Maybe<Scalars['DateTime']['output']>;
};

export type PurchaseRequestAggridOutput = {
  __typename?: 'PurchaseRequestAggridOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<PurchaseRequest>;
};

export type PurchaseRequestCreateInput = {
  accepted_remark?: InputMaybe<Scalars['String']['input']>;
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  approval_step?: InputMaybe<Scalars['Int']['input']>;
  approver_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  attachment_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  branch_id: Scalars['Int']['input'];
  created_by?: InputMaybe<CreatorInputObject>;
  delivery_address?: InputMaybe<Scalars['Json']['input']>;
  expected_date?: InputMaybe<Scalars['DateTime']['input']>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  issue_date?: InputMaybe<Scalars['DateTime']['input']>;
  item_list?: InputMaybe<Array<PurchaseItemCreateInput>>;
  main_status?: InputMaybe<Scalars['String']['input']>;
  reference_document_list?: InputMaybe<Array<PurchaseReferenceDocumentInput>>;
  reference_no?: InputMaybe<Scalars['String']['input']>;
  related_user_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  remark?: InputMaybe<Scalars['String']['input']>;
  requester?: InputMaybe<Scalars['Json']['input']>;
  reviewer_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  tag_id_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  template_remark_id?: InputMaybe<Scalars['String']['input']>;
  unique_id: Scalars['String']['input'];
  within_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PurchaseRequestUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseRequestUpdateInput = {
  accepted_remark?: InputMaybe<Scalars['String']['input']>;
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  approval_step?: InputMaybe<Scalars['Int']['input']>;
  approver_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  attachment_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  branch_id: Scalars['Int']['input'];
  delivery_address?: InputMaybe<Scalars['Json']['input']>;
  expected_date?: InputMaybe<Scalars['DateTime']['input']>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  issue_date?: InputMaybe<Scalars['DateTime']['input']>;
  item_list?: InputMaybe<Array<PurchaseItemUpsertInput>>;
  last_updated_by?: InputMaybe<CreatorInputObject>;
  main_status?: InputMaybe<Scalars['String']['input']>;
  reference_document_list?: InputMaybe<Array<PurchaseReferenceDocumentInput>>;
  reference_no?: InputMaybe<Scalars['String']['input']>;
  related_user_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  remark?: InputMaybe<Scalars['String']['input']>;
  requester?: InputMaybe<Scalars['Json']['input']>;
  reviewer_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  tag_id_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  template_remark_id?: InputMaybe<Scalars['String']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
  within_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PurchaseRequestView = {
  __typename?: 'PurchaseRequestView';
  branch_id?: Maybe<Scalars['Int']['output']>;
  branch_name?: Maybe<Scalars['String']['output']>;
  branch_unique_id?: Maybe<Scalars['String']['output']>;
  branch_unique_id_name?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_by_object?: Maybe<Scalars['Json']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  expected_date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_list?: Maybe<Array<PurchaseItem>>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  reference_document_list?: Maybe<Array<Scalars['String']['output']>>;
  reference_document_object_list?: Maybe<Array<Scalars['Json']['output']>>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['String']['output']>>;
  related_user_object_list?: Maybe<Array<Scalars['Json']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  requester?: Maybe<Scalars['String']['output']>;
  requester_object?: Maybe<Scalars['Json']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tag_list?: Maybe<Array<Scalars['String']['output']>>;
  unique_id: Scalars['String']['output'];
  warehouse_id?: Maybe<Scalars['Int']['output']>;
  warehouse_name?: Maybe<Scalars['String']['output']>;
  within_date?: Maybe<Scalars['DateTime']['output']>;
};

export type PurchaseRequestViewAggridOutput = {
  __typename?: 'PurchaseRequestViewAggridOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<PurchaseRequestView>;
};

export type PurchaseReturn = {
  __typename?: 'PurchaseReturn';
  additional_discount?: Maybe<Scalars['Float']['output']>;
  additional_discount_type?: Maybe<AdditionalDiscountType>;
  aggrid_status?: Maybe<Scalars['String']['output']>;
  approval_step?: Maybe<Scalars['Int']['output']>;
  approver_list?: Maybe<Array<Scalars['Json']['output']>>;
  branch: Branch;
  branch_id: Scalars['Int']['output'];
  created_by?: Maybe<CreatorObject>;
  created_date: Scalars['DateTime']['output'];
  credit_day?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currency_display_name?: Maybe<Scalars['String']['output']>;
  delivery_address?: Maybe<Scalars['Json']['output']>;
  delivery_date?: Maybe<Scalars['DateTime']['output']>;
  exchange_rate?: Maybe<Scalars['Float']['output']>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_list?: Maybe<Array<PurchaseItem>>;
  last_updated_by?: Maybe<CreatorObject>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_vat_type?: Maybe<PriceVatType>;
  reason_to_return?: Maybe<Scalars['String']['output']>;
  reference_document_list?: Maybe<Array<PurchaseReferenceDocument>>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['Json']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  reviewer_list?: Maybe<Array<Scalars['Json']['output']>>;
  sub_status?: Maybe<Scalars['String']['output']>;
  tag_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  tag_list?: Maybe<Array<Tag>>;
  template_remark_id?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  vendor_details?: Maybe<Scalars['Json']['output']>;
  vendor_unique_id?: Maybe<Scalars['String']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
};

export type PurchaseReturnAggridOutput = {
  __typename?: 'PurchaseReturnAggridOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<PurchaseReturn>;
};

export type PurchaseReturnCreateInput = {
  additional_discount?: InputMaybe<Scalars['Float']['input']>;
  additional_discount_type?: InputMaybe<AdditionalDiscountType>;
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  approval_step?: InputMaybe<Scalars['Int']['input']>;
  approver_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  branch_id: Scalars['Int']['input'];
  created_by?: InputMaybe<CreatorInputObject>;
  credit_day?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currency_display_name?: InputMaybe<Scalars['String']['input']>;
  delivery_address?: InputMaybe<Scalars['Json']['input']>;
  delivery_date?: InputMaybe<Scalars['DateTime']['input']>;
  exchange_rate?: InputMaybe<Scalars['Float']['input']>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  issue_date?: InputMaybe<Scalars['DateTime']['input']>;
  item_list?: InputMaybe<Array<PurchaseItemCreateInput>>;
  main_status?: InputMaybe<Scalars['String']['input']>;
  net_amount?: InputMaybe<Scalars['Float']['input']>;
  post_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  price_vat_type?: InputMaybe<PriceVatType>;
  reason_to_return?: InputMaybe<Scalars['String']['input']>;
  reference_document_list?: InputMaybe<Array<PurchaseReferenceDocumentInput>>;
  reference_no?: InputMaybe<Scalars['String']['input']>;
  related_user_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  remark?: InputMaybe<Scalars['String']['input']>;
  reviewer_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  tag_id_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  template_remark_id?: InputMaybe<Scalars['String']['input']>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  unique_id: Scalars['String']['input'];
  vat_0_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_7_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_exempted_amount?: InputMaybe<Scalars['Float']['input']>;
  vendor_details?: InputMaybe<Scalars['Json']['input']>;
  vendor_unique_id?: InputMaybe<Scalars['String']['input']>;
  withholding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
};

export type PurchaseReturnUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseReturnUpdateInput = {
  additional_discount?: InputMaybe<Scalars['Float']['input']>;
  additional_discount_type?: InputMaybe<AdditionalDiscountType>;
  aggrid_status?: InputMaybe<Scalars['String']['input']>;
  approval_step?: InputMaybe<Scalars['Int']['input']>;
  approver_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  branch_id: Scalars['Int']['input'];
  credit_day?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currency_display_name?: InputMaybe<Scalars['String']['input']>;
  delivery_address?: InputMaybe<Scalars['Json']['input']>;
  delivery_date?: InputMaybe<Scalars['DateTime']['input']>;
  exchange_rate?: InputMaybe<Scalars['Float']['input']>;
  flag_status?: InputMaybe<Array<Scalars['String']['input']>>;
  issue_date?: InputMaybe<Scalars['DateTime']['input']>;
  item_list?: InputMaybe<Array<PurchaseItemUpsertInput>>;
  last_updated_by?: InputMaybe<CreatorInputObject>;
  main_status?: InputMaybe<Scalars['String']['input']>;
  net_amount?: InputMaybe<Scalars['Float']['input']>;
  post_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  price_vat_type?: InputMaybe<PriceVatType>;
  reason_to_return?: InputMaybe<Scalars['String']['input']>;
  reference_document_list?: InputMaybe<Array<PurchaseReferenceDocumentInput>>;
  reference_no?: InputMaybe<Scalars['String']['input']>;
  related_user_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  remark?: InputMaybe<Scalars['String']['input']>;
  reviewer_list?: InputMaybe<Array<Scalars['Json']['input']>>;
  sub_status?: InputMaybe<Scalars['String']['input']>;
  tag_id_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  template_remark_id?: InputMaybe<Scalars['String']['input']>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
  vat_0_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_7_percent_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_exempted_amount?: InputMaybe<Scalars['Float']['input']>;
  vendor_details?: InputMaybe<Scalars['Json']['input']>;
  vendor_unique_id?: InputMaybe<Scalars['String']['input']>;
  withholding_tax_amount?: InputMaybe<Scalars['Float']['input']>;
};

export type PurchaseReturnView = {
  __typename?: 'PurchaseReturnView';
  branch_id?: Maybe<Scalars['Int']['output']>;
  branch_name?: Maybe<Scalars['String']['output']>;
  branch_unique_id?: Maybe<Scalars['String']['output']>;
  branch_unique_id_name?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_by_object?: Maybe<Scalars['Json']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  delivery_date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_list?: Maybe<Array<PurchaseItem>>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  reason_to_return?: Maybe<Scalars['String']['output']>;
  reference_document_list?: Maybe<Array<Scalars['String']['output']>>;
  reference_document_object_list?: Maybe<Array<Scalars['Json']['output']>>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['String']['output']>>;
  related_user_object_list?: Maybe<Array<Scalars['Json']['output']>>;
  status?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  vendor_name?: Maybe<Scalars['String']['output']>;
  vendor_unique_id?: Maybe<Scalars['String']['output']>;
};

export type PurchaseReturnViewAggridOutput = {
  __typename?: 'PurchaseReturnViewAggridOutput';
  count?: Maybe<Scalars['Int']['output']>;
  results: Array<PurchaseReturnView>;
};

export type Query = {
  __typename?: 'Query';
  GenerateExport: Scalars['String']['output'];
  PurchaseItemFindMany?: Maybe<Array<Maybe<PurchaseItem>>>;
  PurchaseOrderByBranchExportViewsAggird: PurchaseOrderByBranchExportViewAggirdOutput;
  PurchaseOrderByItemExportViewsAggird: PurchaseOrderByItemExportViewAggirdOutput;
  PurchaseOrderByVendorExportViewsAggird: PurchaseOrderByVendorExportViewAggirdOutput;
  PurchaseOrderFindUnique: PurchaseOrder;
  PurchaseOrderViewsAggrid?: Maybe<PurchaseOrderViewAggridOutput>;
  PurchaseOrdersAggrid: PurchaseOrderAggridOutput;
  PurchaseOrdersFindAll?: Maybe<Array<PurchaseOrder>>;
  PurchaseRequestFindUnique: PurchaseRequest;
  PurchaseRequestViewsAggrid?: Maybe<PurchaseRequestViewAggridOutput>;
  PurchaseRequestsAggrid: PurchaseRequestAggridOutput;
  PurchaseRequestsFindAll?: Maybe<Array<PurchaseRequest>>;
  PurchaseReturnFindUnique: PurchaseReturn;
  PurchaseReturnViewsAggrid?: Maybe<PurchaseReturnViewAggridOutput>;
  PurchaseReturnsAggrid: PurchaseReturnAggridOutput;
  PurchaseReturnsFindAll?: Maybe<Array<PurchaseReturn>>;
  UniqueIdGenerate: Scalars['String']['output'];
  UniqueIdIsExist: Scalars['Boolean']['output'];
};


export type QueryGenerateExportArgs = {
  input?: InputMaybe<ExportGenerateInput>;
};


export type QueryPurchaseItemFindManyArgs = {
  input?: InputMaybe<PurchaseItemFindManyInput>;
};


export type QueryPurchaseOrderByBranchExportViewsAggirdArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryPurchaseOrderByItemExportViewsAggirdArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryPurchaseOrderByVendorExportViewsAggirdArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryPurchaseOrderFindUniqueArgs = {
  uniqueInput: PurchaseOrderUniqueInput;
};


export type QueryPurchaseOrderViewsAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryPurchaseOrdersAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryPurchaseRequestFindUniqueArgs = {
  uniqueInput: PurchaseRequestUniqueInput;
};


export type QueryPurchaseRequestViewsAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryPurchaseRequestsAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryPurchaseReturnFindUniqueArgs = {
  uniqueInput: PurchaseReturnUniqueInput;
};


export type QueryPurchaseReturnViewsAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryPurchaseReturnsAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryUniqueIdGenerateArgs = {
  modelType: PurchaseModelType;
};


export type QueryUniqueIdIsExistArgs = {
  modelType: PurchaseModelType;
  uniqueId: Scalars['String']['input'];
};

export type Quotation = {
  __typename?: 'Quotation';
  accepted_date?: Maybe<Scalars['DateTime']['output']>;
  accepted_remark?: Maybe<Scalars['String']['output']>;
  account_id?: Maybe<Scalars['String']['output']>;
  additional_discount?: Maybe<Scalars['Float']['output']>;
  additional_discount_type?: Maybe<AdditionalDiscountType>;
  aggrid_status?: Maybe<Scalars['String']['output']>;
  approval_step?: Maybe<Scalars['Int']['output']>;
  approver_list?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  attachment_list?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  branch: Branch;
  branch_id: Scalars['Int']['output'];
  contact_person_list?: Maybe<Array<Scalars['Json']['output']>>;
  contact_unique_id?: Maybe<Scalars['String']['output']>;
  created_by: Scalars['Json']['output'];
  created_date: Scalars['DateTime']['output'];
  credit_day?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customer_details?: Maybe<Scalars['Json']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['DateTime']['output']>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_list?: Maybe<Array<Maybe<SalesItem>>>;
  item_price_list?: Maybe<ItemPriceList>;
  item_price_list_id?: Maybe<Scalars['Int']['output']>;
  last_updated_by?: Maybe<Scalars['Json']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_vat_type?: Maybe<PriceVatType>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['Json']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  reviewer_list?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  sales_channel?: Maybe<SalesChannel>;
  sales_channel_id?: Maybe<Scalars['Int']['output']>;
  sales_contact?: Maybe<Array<Scalars['Json']['output']>>;
  sales_type?: Maybe<Scalars['String']['output']>;
  shipping_cost?: Maybe<Scalars['Float']['output']>;
  sub_status?: Maybe<Scalars['String']['output']>;
  tag_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  tag_list?: Maybe<Array<Maybe<Tag>>>;
  template_remark_id?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
};

export enum ReceiveType {
  Amount = 'amount',
  Percent = 'percent'
}

export type ReferencePurchaseLineItem = {
  __typename?: 'ReferencePurchaseLineItem';
  line_item_document_type: Scalars['String']['output'];
  line_item_document_unique_id: Scalars['String']['output'];
  line_item_unique_id: Scalars['String']['output'];
};

export type ReferencePurchaseLineItemInput = {
  line_item_document_type: Scalars['String']['input'];
  line_item_document_unique_id: Scalars['String']['input'];
  line_item_unique_id: Scalars['String']['input'];
};

export type ReferenceSalesDocument = {
  __typename?: 'ReferenceSalesDocument';
  document_id?: Maybe<Scalars['Int']['output']>;
  document_type?: Maybe<SalesReferenceDocumentType>;
  document_unique_id?: Maybe<Scalars['String']['output']>;
};

export type ReferenceSalesDocumentInput = {
  document_id?: InputMaybe<Scalars['Int']['input']>;
  document_type?: InputMaybe<SalesReferenceDocumentType>;
  document_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ReferenceSalesLineItem = {
  __typename?: 'ReferenceSalesLineItem';
  line_item_document_type: Scalars['String']['output'];
  line_item_unique_id: Scalars['String']['output'];
};

export type ReferenceSalesLineItemInput = {
  line_item_document_type: Scalars['String']['input'];
  line_item_unique_id: Scalars['String']['input'];
};

export type RolePermission = {
  __typename?: 'RolePermission';
  approval?: Maybe<AccessPermission>;
  branch?: Maybe<AccessPermission>;
  cash_sales?: Maybe<AccessPermission>;
  company?: Maybe<AccessPermission>;
  contact?: Maybe<AccessPermission>;
  contact_export?: Maybe<AccessPermission>;
  contact_setting?: Maybe<AccessPermission>;
  customer?: Maybe<AccessPermission>;
  customer_deposit?: Maybe<AccessPermission>;
  delivery_order?: Maybe<AccessPermission>;
  employee?: Maybe<AccessPermission>;
  goods_adjust?: Maybe<AccessPermission>;
  goods_issue?: Maybe<AccessPermission>;
  goods_receive?: Maybe<AccessPermission>;
  goods_return?: Maybe<AccessPermission>;
  goods_transfer?: Maybe<AccessPermission>;
  inventory?: Maybe<AccessPermission>;
  inventory_export?: Maybe<AccessPermission>;
  inventory_report?: Maybe<AccessPermission>;
  inventory_setting?: Maybe<AccessPermission>;
  item?: Maybe<AccessPermission>;
  logistic?: Maybe<AccessPermission>;
  logistic_export?: Maybe<AccessPermission>;
  logistic_report?: Maybe<AccessPermission>;
  logistic_setting?: Maybe<AccessPermission>;
  marketing?: Maybe<AccessPermission>;
  marketing_export?: Maybe<AccessPermission>;
  price_list?: Maybe<AccessPermission>;
  promotion?: Maybe<AccessPermission>;
  purchase?: Maybe<AccessPermission>;
  purchase_export?: Maybe<AccessPermission>;
  purchase_order?: Maybe<AccessPermission>;
  purchase_report?: Maybe<AccessPermission>;
  purchase_request?: Maybe<AccessPermission>;
  purchase_return?: Maybe<AccessPermission>;
  quotation?: Maybe<AccessPermission>;
  role?: Maybe<AccessPermission>;
  sales?: Maybe<AccessPermission>;
  sales_export?: Maybe<AccessPermission>;
  sales_invoice?: Maybe<AccessPermission>;
  sales_order?: Maybe<AccessPermission>;
  sales_report?: Maybe<AccessPermission>;
  sales_return?: Maybe<AccessPermission>;
  sales_setting?: Maybe<AccessPermission>;
  setting?: Maybe<AccessPermission>;
  user_account?: Maybe<AccessPermission>;
  user_export?: Maybe<AccessPermission>;
  vendor?: Maybe<AccessPermission>;
  zone?: Maybe<AccessPermission>;
};

export type RolePermissionInput = {
  approval?: InputMaybe<AccessPermissionInput>;
  branch?: InputMaybe<AccessPermissionInput>;
  cash_sales?: InputMaybe<AccessPermissionInput>;
  company?: InputMaybe<AccessPermissionInput>;
  contact?: InputMaybe<AccessPermissionInput>;
  contact_export?: InputMaybe<AccessPermissionInput>;
  contact_setting?: InputMaybe<AccessPermissionInput>;
  customer?: InputMaybe<AccessPermissionInput>;
  customer_deposit?: InputMaybe<AccessPermissionInput>;
  delivery_order?: InputMaybe<AccessPermissionInput>;
  employee?: InputMaybe<AccessPermissionInput>;
  goods_adjust?: InputMaybe<AccessPermissionInput>;
  goods_issue?: InputMaybe<AccessPermissionInput>;
  goods_receive?: InputMaybe<AccessPermissionInput>;
  goods_return?: InputMaybe<AccessPermissionInput>;
  goods_transfer?: InputMaybe<AccessPermissionInput>;
  inventory?: InputMaybe<AccessPermissionInput>;
  inventory_export?: InputMaybe<AccessPermissionInput>;
  inventory_report?: InputMaybe<AccessPermissionInput>;
  inventory_setting?: InputMaybe<AccessPermissionInput>;
  item?: InputMaybe<AccessPermissionInput>;
  logistic?: InputMaybe<AccessPermissionInput>;
  logistic_export?: InputMaybe<AccessPermissionInput>;
  logistic_report?: InputMaybe<AccessPermissionInput>;
  logistic_setting?: InputMaybe<AccessPermissionInput>;
  marketing?: InputMaybe<AccessPermissionInput>;
  marketing_export?: InputMaybe<AccessPermissionInput>;
  price_list?: InputMaybe<AccessPermissionInput>;
  promotion?: InputMaybe<AccessPermissionInput>;
  purchase?: InputMaybe<AccessPermissionInput>;
  purchase_export?: InputMaybe<AccessPermissionInput>;
  purchase_order?: InputMaybe<AccessPermissionInput>;
  purchase_report?: InputMaybe<AccessPermissionInput>;
  purchase_request?: InputMaybe<AccessPermissionInput>;
  purchase_return?: InputMaybe<AccessPermissionInput>;
  quotation?: InputMaybe<AccessPermissionInput>;
  role?: InputMaybe<AccessPermissionInput>;
  sales?: InputMaybe<AccessPermissionInput>;
  sales_export?: InputMaybe<AccessPermissionInput>;
  sales_invoice?: InputMaybe<AccessPermissionInput>;
  sales_order?: InputMaybe<AccessPermissionInput>;
  sales_report?: InputMaybe<AccessPermissionInput>;
  sales_return?: InputMaybe<AccessPermissionInput>;
  sales_setting?: InputMaybe<AccessPermissionInput>;
  setting?: InputMaybe<AccessPermissionInput>;
  user_account?: InputMaybe<AccessPermissionInput>;
  user_export?: InputMaybe<AccessPermissionInput>;
  vendor?: InputMaybe<AccessPermissionInput>;
  zone?: InputMaybe<AccessPermissionInput>;
};

export type SalesChannel = {
  __typename?: 'SalesChannel';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  item_price_list?: Maybe<Array<Maybe<ItemPriceList>>>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name_en: Scalars['String']['output'];
  name_th: Scalars['String']['output'];
  quotation_list?: Maybe<Array<Maybe<Quotation>>>;
  unique_id: Scalars['String']['output'];
};

export enum SalesChannelType {
  All = 'all',
  SpecificChannels = 'specific_channels',
  SpecificSales = 'specific_sales'
}

export type SalesDeduction = {
  __typename?: 'SalesDeduction';
  branch_id: Scalars['Int']['output'];
  credit_balance?: Maybe<Scalars['Float']['output']>;
  deduction_amount?: Maybe<Scalars['Float']['output']>;
  deduction_issue_date?: Maybe<Scalars['DateTime']['output']>;
  document_type?: Maybe<Scalars['String']['output']>;
  document_unique_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  reference_document_type: SalesReferenceDocumentType;
  reference_unique_id: Scalars['String']['output'];
  remark?: Maybe<Scalars['String']['output']>;
};

export type SalesInvoice = {
  __typename?: 'SalesInvoice';
  additional_discount?: Maybe<Scalars['Float']['output']>;
  additional_discount_type?: Maybe<AdditionalDiscountType>;
  aggrid_status?: Maybe<Scalars['String']['output']>;
  approval_step?: Maybe<Scalars['Int']['output']>;
  approver_list?: Maybe<Array<Scalars['Json']['output']>>;
  branch?: Maybe<Branch>;
  branch_id: Scalars['Int']['output'];
  contact_person_list?: Maybe<Array<Scalars['Json']['output']>>;
  created_by: Scalars['Json']['output'];
  created_date: Scalars['DateTime']['output'];
  credit_day?: Maybe<Scalars['Int']['output']>;
  currency: Scalars['String']['output'];
  customer_details: Scalars['Json']['output'];
  customer_unique_id: Scalars['String']['output'];
  deduction_document_list?: Maybe<Array<SalesDeduction>>;
  deduction_total_amount?: Maybe<Scalars['Float']['output']>;
  due_date: Scalars['DateTime']['output'];
  external_reference_no?: Maybe<Scalars['String']['output']>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  is_original_print?: Maybe<Scalars['Json']['output']>;
  issue_date: Scalars['DateTime']['output'];
  item_list?: Maybe<Array<SalesItem>>;
  item_price_list?: Maybe<ItemPriceList>;
  item_price_list_id?: Maybe<Scalars['Int']['output']>;
  last_updated_by?: Maybe<Scalars['Json']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  need_tax_invoice?: Maybe<Scalars['Boolean']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  paid_net_amount?: Maybe<Scalars['Float']['output']>;
  paid_total_amount?: Maybe<Scalars['Float']['output']>;
  payment_list?: Maybe<Array<SalesPayment>>;
  payment_total_amount?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_vat_type: PriceVatType;
  reference_document_list?: Maybe<Array<Scalars['Json']['output']>>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['Json']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  reviewer_list?: Maybe<Array<Scalars['Json']['output']>>;
  sales_channel?: Maybe<SalesChannel>;
  sales_channel_id?: Maybe<Scalars['Int']['output']>;
  sales_contact?: Maybe<Array<Scalars['Json']['output']>>;
  sales_type?: Maybe<Scalars['String']['output']>;
  sub_status?: Maybe<Scalars['String']['output']>;
  tag_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  tag_list?: Maybe<Array<Tag>>;
  tax_invoice_date?: Maybe<Scalars['DateTime']['output']>;
  tax_invoice_no?: Maybe<Scalars['String']['output']>;
  template_remark_id?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
};

export type SalesItem = {
  __typename?: 'SalesItem';
  barcode?: Maybe<Scalars['String']['output']>;
  branch_id: Scalars['Int']['output'];
  discount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  item_id?: Maybe<Scalars['Int']['output']>;
  item_img_url?: Maybe<Array<Scalars['String']['output']>>;
  item_name?: Maybe<Scalars['String']['output']>;
  item_sku_desc?: Maybe<Scalars['String']['output']>;
  item_sku_name: Scalars['String']['output'];
  item_unique_id: Scalars['String']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_per_unit?: Maybe<Scalars['Float']['output']>;
  promotion_discount?: Maybe<Scalars['Float']['output']>;
  qty: Scalars['Float']['output'];
  qty_invoiced?: Maybe<Scalars['Float']['output']>;
  qty_issued?: Maybe<Scalars['Float']['output']>;
  qty_received?: Maybe<Scalars['Float']['output']>;
  qty_returned?: Maybe<Scalars['Float']['output']>;
  qty_shipped?: Maybe<Scalars['Float']['output']>;
  qty_to_ship?: Maybe<Scalars['Float']['output']>;
  reference_document_type: SalesReferenceDocumentType;
  reference_line_item?: Maybe<ReferenceSalesLineItem>;
  reference_unique_id: Scalars['String']['output'];
  remark?: Maybe<Scalars['String']['output']>;
  so_qty?: Maybe<Scalars['Float']['output']>;
  stock_qty?: Maybe<Scalars['Float']['output']>;
  tracability: TraceAbilityEnum;
  unique_id: Scalars['String']['output'];
  uom_id?: Maybe<Scalars['Int']['output']>;
  uom_name?: Maybe<Scalars['String']['output']>;
  vat_percentage?: Maybe<Scalars['String']['output']>;
  volume: Scalars['Float']['output'];
  weight: Scalars['Float']['output'];
  withholding_tax_type?: Maybe<Scalars['String']['output']>;
  withholding_tax_value?: Maybe<Scalars['Float']['output']>;
};

export enum SalesModelType {
  CashSales = 'cash_sales',
  CashSalesTax = 'cash_sales_tax',
  CustomerDeposit = 'customer_deposit',
  CustomerDepositTax = 'customer_deposit_tax',
  Quotation = 'quotation',
  SalesInvoice = 'sales_invoice',
  SalesInvoiceTax = 'sales_invoice_tax',
  SalesOrder = 'sales_order',
  SalesReturn = 'sales_return'
}

export type SalesOrder = {
  __typename?: 'SalesOrder';
  account_id?: Maybe<Scalars['String']['output']>;
  additional_discount?: Maybe<Scalars['Float']['output']>;
  additional_discount_type?: Maybe<AdditionalDiscountType>;
  aggrid_status?: Maybe<Scalars['String']['output']>;
  approval_step?: Maybe<Scalars['Int']['output']>;
  approver_list?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  branch: Branch;
  branch_id: Scalars['Int']['output'];
  contact_person_list?: Maybe<Array<Scalars['Json']['output']>>;
  created_by: Scalars['Json']['output'];
  created_date: Scalars['DateTime']['output'];
  credit_day?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customer_details?: Maybe<Scalars['Json']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  delivery_date?: Maybe<Scalars['DateTime']['output']>;
  delivery_status?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['DateTime']['output']>;
  external_reference_no?: Maybe<Scalars['String']['output']>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  good_issue_status?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  issue_date?: Maybe<Scalars['DateTime']['output']>;
  item_list?: Maybe<Array<SalesItem>>;
  item_price_list?: Maybe<ItemPriceList>;
  item_price_list_id?: Maybe<Scalars['Int']['output']>;
  last_updated_by?: Maybe<Scalars['Json']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  payments_receipt_status?: Maybe<Scalars['String']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_vat_type?: Maybe<PriceVatType>;
  reference_document_list?: Maybe<Array<Scalars['Json']['output']>>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['Json']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  reviewer_list?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  sales_channel?: Maybe<SalesChannel>;
  sales_channel_id?: Maybe<Scalars['Int']['output']>;
  sales_contact?: Maybe<Array<Scalars['Json']['output']>>;
  sales_invoice_status?: Maybe<Scalars['String']['output']>;
  sales_type?: Maybe<Scalars['String']['output']>;
  shipping_cost?: Maybe<Scalars['Float']['output']>;
  sub_status?: Maybe<Scalars['String']['output']>;
  tag_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  tag_list?: Maybe<Array<Tag>>;
  template_remark_id?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
};

export type SalesPayment = {
  __typename?: 'SalesPayment';
  branch_id: Scalars['Int']['output'];
  cheque_date?: Maybe<Scalars['DateTime']['output']>;
  cheque_no?: Maybe<Scalars['String']['output']>;
  cheque_provider?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_withholding_tax?: Maybe<Scalars['Boolean']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  payment_amount?: Maybe<Scalars['Float']['output']>;
  payment_channel_id?: Maybe<Scalars['Int']['output']>;
  payment_channel_name?: Maybe<Scalars['String']['output']>;
  payment_channel_payment_name?: Maybe<Scalars['String']['output']>;
  payment_channel_unique_id?: Maybe<Scalars['String']['output']>;
  payment_date?: Maybe<Scalars['DateTime']['output']>;
  reference_document_type: SalesReferenceDocumentType;
  reference_unique_id: Scalars['String']['output'];
  remark?: Maybe<Scalars['String']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
  withholding_tax_rate?: Maybe<Scalars['String']['output']>;
};

export enum SalesReferenceDocumentType {
  CashSales = 'cash_sales',
  CustomerDeposit = 'customer_deposit',
  Quotation = 'quotation',
  SalesInvoice = 'sales_invoice',
  SalesOrder = 'sales_order',
  SalesReturn = 'sales_return',
  TaxInvoice = 'tax_invoice'
}

export type SalesReturn = {
  __typename?: 'SalesReturn';
  additional_discount?: Maybe<Scalars['Float']['output']>;
  additional_discount_type?: Maybe<AdditionalDiscountType>;
  aggrid_status?: Maybe<Scalars['String']['output']>;
  approval_step?: Maybe<Scalars['Int']['output']>;
  approver_list?: Maybe<Array<Scalars['Json']['output']>>;
  branch?: Maybe<Branch>;
  branch_id: Scalars['Int']['output'];
  contact_person_list?: Maybe<Array<Scalars['Json']['output']>>;
  created_by: Scalars['Json']['output'];
  created_date: Scalars['DateTime']['output'];
  credit_day?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customer_details?: Maybe<Scalars['Json']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  due_date: Scalars['DateTime']['output'];
  external_reference_no?: Maybe<Scalars['String']['output']>;
  flag_status?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  is_effect_stock?: Maybe<Scalars['Boolean']['output']>;
  issue_date: Scalars['DateTime']['output'];
  item_list?: Maybe<Array<SalesItem>>;
  item_price_list?: Maybe<ItemPriceList>;
  item_price_list_id?: Maybe<Scalars['Int']['output']>;
  last_updated_by?: Maybe<Scalars['Json']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status?: Maybe<Scalars['String']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_vat_type?: Maybe<PriceVatType>;
  reason_to_return?: Maybe<Scalars['String']['output']>;
  reference_document_list?: Maybe<Array<Scalars['Json']['output']>>;
  reference_no?: Maybe<Scalars['String']['output']>;
  related_user_list?: Maybe<Array<Scalars['Json']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  reviewer_list?: Maybe<Array<Scalars['Json']['output']>>;
  sales_channel?: Maybe<SalesChannel>;
  sales_channel_id?: Maybe<Scalars['Int']['output']>;
  sales_contact?: Maybe<Array<Scalars['Json']['output']>>;
  sales_type?: Maybe<Scalars['String']['output']>;
  sub_status?: Maybe<Scalars['String']['output']>;
  tag_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  tag_list?: Maybe<Array<Tag>>;
  template_remark_id?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
  vat_0_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_7_percent_amount?: Maybe<Scalars['Float']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_exempted_amount?: Maybe<Scalars['Float']['output']>;
  withholding_tax_amount?: Maybe<Scalars['Float']['output']>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type Tag = {
  __typename?: 'Tag';
  document_type: TagDocumentType;
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
};

export enum TagDocumentType {
  Batch = 'batch',
  CashSales = 'cash_sales',
  Contact = 'contact',
  CreditNote = 'credit_note',
  Customer = 'customer',
  CustomerDeposit = 'customer_deposit',
  DeliveryOrder = 'delivery_order',
  DeliveryTrip = 'delivery_trip',
  Employee = 'employee',
  Event = 'event',
  GoodsAdjust = 'goods_adjust',
  GoodsIssue = 'goods_issue',
  GoodsReceive = 'goods_receive',
  GoodsTransfer = 'goods_transfer',
  Inventory = 'inventory',
  Item = 'item',
  PaymentMade = 'payment_made',
  PaymentReceive = 'payment_receive',
  Project = 'project',
  Promotion = 'promotion',
  Purchase = 'purchase',
  PurchaseInvoice = 'purchase_invoice',
  PurchaseOrder = 'purchase_order',
  PurchaseRequest = 'purchase_request',
  PurchaseReturn = 'purchase_return',
  Quotation = 'quotation',
  Role = 'role',
  Sale = 'sale',
  SalesInvoice = 'sales_invoice',
  SalesOrder = 'sales_order',
  SalesReturn = 'sales_return',
  Serial = 'serial',
  Task = 'task',
  Vendor = 'vendor'
}

export enum Tracability {
  Lot = 'lot',
  Normal = 'normal',
  Serial = 'serial'
}

export enum TraceAbilityEnum {
  Lot = 'lot',
  Normal = 'normal',
  Serial = 'serial'
}

export type TraceEntry = {
  __typename?: 'TraceEntry';
  additional_cost?: Maybe<Scalars['Float']['output']>;
  barcode?: Maybe<Scalars['String']['output']>;
  cost_price?: Maybe<Scalars['Float']['output']>;
  created_date: Scalars['DateTime']['output'];
  delivery_order_unique_id?: Maybe<Scalars['String']['output']>;
  destination_bin_location?: Maybe<BinLocation>;
  destination_bin_location_id?: Maybe<Scalars['Int']['output']>;
  destination_scanned_by?: Maybe<Scalars['Json']['output']>;
  destination_scanned_date?: Maybe<Scalars['DateTime']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  document_item_qty?: Maybe<Scalars['Int']['output']>;
  expired_date?: Maybe<Scalars['DateTime']['output']>;
  goods_adjust_unique_id?: Maybe<Scalars['String']['output']>;
  goods_issue_unique_id?: Maybe<Scalars['String']['output']>;
  goods_receive_unique_id?: Maybe<Scalars['String']['output']>;
  goods_return_unique_id?: Maybe<Scalars['String']['output']>;
  goods_transfer_unique_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_stockable: Scalars['Boolean']['output'];
  item_img_url: Array<Scalars['String']['output']>;
  item_name: Scalars['String']['output'];
  item_unique_id: Scalars['String']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  lot_date?: Maybe<Scalars['DateTime']['output']>;
  manufactured_date?: Maybe<Scalars['DateTime']['output']>;
  po_reference_unique_id?: Maybe<Scalars['String']['output']>;
  posted_date?: Maybe<Scalars['DateTime']['output']>;
  posted_qty?: Maybe<Scalars['Int']['output']>;
  qty: Scalars['Int']['output'];
  reference_line_item?: Maybe<InventoryReferenceLineItem>;
  reference_unique_id?: Maybe<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  scanned_by?: Maybe<Scalars['Json']['output']>;
  serial_no?: Maybe<Scalars['String']['output']>;
  sku_name: Scalars['String']['output'];
  source_bin_location?: Maybe<BinLocation>;
  source_bin_location_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stock_qty?: Maybe<Scalars['Int']['output']>;
  tracability: Tracability;
  type: InventoryDocumentType;
  unique_id: Scalars['String']['output'];
  uom?: Maybe<Unit>;
  uom_id?: Maybe<Scalars['Int']['output']>;
};

export type TraceEntryCreateInput = {
  additional_cost?: InputMaybe<Scalars['Float']['input']>;
  barcode?: InputMaybe<Scalars['String']['input']>;
  cost_price?: InputMaybe<Scalars['Float']['input']>;
  delivery_order_unique_id?: InputMaybe<Scalars['String']['input']>;
  destination_bin_location_id?: InputMaybe<Scalars['Int']['input']>;
  destination_scanned_by?: InputMaybe<Scalars['Json']['input']>;
  destination_scanned_date?: InputMaybe<Scalars['DateTime']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  document_item_qty?: InputMaybe<Scalars['Int']['input']>;
  expired_date?: InputMaybe<Scalars['DateTime']['input']>;
  goods_adjust_unique_id?: InputMaybe<Scalars['String']['input']>;
  goods_issue_unique_id?: InputMaybe<Scalars['String']['input']>;
  goods_receive_unique_id?: InputMaybe<Scalars['String']['input']>;
  goods_return_unique_id?: InputMaybe<Scalars['String']['input']>;
  goods_transfer_unique_id?: InputMaybe<Scalars['String']['input']>;
  is_stockable?: InputMaybe<Scalars['Boolean']['input']>;
  item_img_url?: InputMaybe<Array<Scalars['String']['input']>>;
  item_name: Scalars['String']['input'];
  item_unique_id: Scalars['String']['input'];
  lot_date?: InputMaybe<Scalars['DateTime']['input']>;
  manufactured_date?: InputMaybe<Scalars['DateTime']['input']>;
  po_reference_unique_id?: InputMaybe<Scalars['String']['input']>;
  posted_date?: InputMaybe<Scalars['DateTime']['input']>;
  posted_qty?: InputMaybe<Scalars['Int']['input']>;
  qty: Scalars['Int']['input'];
  reference_line_item?: InputMaybe<InventoryReferenceLineItemInput>;
  reference_unique_id?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  scanned_by?: InputMaybe<Scalars['Json']['input']>;
  serial_no?: InputMaybe<Scalars['String']['input']>;
  sku_name: Scalars['String']['input'];
  source_bin_location_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  stock_qty?: InputMaybe<Scalars['Int']['input']>;
  tracability: Tracability;
  type?: InputMaybe<InventoryDocumentType>;
  unique_id: Scalars['String']['input'];
  uom_id?: InputMaybe<Scalars['Int']['input']>;
};

export type Unit = {
  __typename?: 'Unit';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name_en?: Maybe<Scalars['String']['output']>;
  name_th: Scalars['String']['output'];
  unique_id: Scalars['String']['output'];
};

export enum UnitScalarField {
  NameTh = 'name_th',
  UniqueId = 'unique_id'
}

export type UomConversion = {
  __typename?: 'UomConversion';
  base_uom_rate: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  target_uom: Unit;
  target_uom_id: Scalars['Int']['output'];
  target_uom_rate: Scalars['Float']['output'];
  uom_group: UomGroup;
  uom_group_id: Scalars['Int']['output'];
};

export type UomGroup = {
  __typename?: 'UomGroup';
  base_uom: Unit;
  base_uom_id: Scalars['Int']['output'];
  convertable_uom_list: Array<Unit>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  unique_id: Scalars['String']['output'];
  uom_conversion_list: Array<UomConversion>;
};

export enum UsageLimitType {
  Limited = 'limited',
  NoLimit = 'no_limit'
}

export type User = {
  __typename?: 'User';
  company_name?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  employee_type?: Maybe<Scalars['String']['output']>;
  first_name: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  img_url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  inactive_date?: Maybe<Scalars['DateTime']['output']>;
  is_sales_employee?: Maybe<Scalars['Boolean']['output']>;
  last_login_branch?: Maybe<Scalars['Int']['output']>;
  last_name: Scalars['String']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  nick_name?: Maybe<Scalars['String']['output']>;
  original_branch: Scalars['Int']['output'];
  original_branch_object?: Maybe<Branch>;
  phone?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  remark_status?: Maybe<Scalars['String']['output']>;
  role_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['Int']['output'];
  title_name?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
  user_permission?: Maybe<UserPermission>;
};

export type UserPermission = {
  __typename?: 'UserPermission';
  approval?: Maybe<AccessPermission>;
  branch?: Maybe<AccessPermission>;
  cash_sales?: Maybe<AccessPermission>;
  company?: Maybe<AccessPermission>;
  contact?: Maybe<AccessPermission>;
  contact_export?: Maybe<AccessPermission>;
  contact_setting?: Maybe<AccessPermission>;
  customer?: Maybe<AccessPermission>;
  customer_deposit?: Maybe<AccessPermission>;
  delivery_order?: Maybe<AccessPermission>;
  employee?: Maybe<AccessPermission>;
  goods_adjust?: Maybe<AccessPermission>;
  goods_issue?: Maybe<AccessPermission>;
  goods_receive?: Maybe<AccessPermission>;
  goods_return?: Maybe<AccessPermission>;
  goods_transfer?: Maybe<AccessPermission>;
  id: Scalars['Int']['output'];
  inventory?: Maybe<AccessPermission>;
  inventory_export?: Maybe<AccessPermission>;
  inventory_report?: Maybe<AccessPermission>;
  inventory_setting?: Maybe<AccessPermission>;
  is_custom: Scalars['Boolean']['output'];
  item?: Maybe<AccessPermission>;
  logistic?: Maybe<AccessPermission>;
  logistic_export?: Maybe<AccessPermission>;
  logistic_report?: Maybe<AccessPermission>;
  logistic_setting?: Maybe<AccessPermission>;
  marketing?: Maybe<AccessPermission>;
  marketing_export?: Maybe<AccessPermission>;
  price_list?: Maybe<AccessPermission>;
  promotion?: Maybe<AccessPermission>;
  purchase?: Maybe<AccessPermission>;
  purchase_export?: Maybe<AccessPermission>;
  purchase_order?: Maybe<AccessPermission>;
  purchase_report?: Maybe<AccessPermission>;
  purchase_request?: Maybe<AccessPermission>;
  purchase_return?: Maybe<AccessPermission>;
  quotation?: Maybe<AccessPermission>;
  role?: Maybe<AccessPermission>;
  sales?: Maybe<AccessPermission>;
  sales_export?: Maybe<AccessPermission>;
  sales_invoice?: Maybe<AccessPermission>;
  sales_order?: Maybe<AccessPermission>;
  sales_report?: Maybe<AccessPermission>;
  sales_return?: Maybe<AccessPermission>;
  sales_setting?: Maybe<AccessPermission>;
  setting?: Maybe<AccessPermission>;
  user_account?: Maybe<AccessPermission>;
  user_export?: Maybe<AccessPermission>;
  user_id: Scalars['Int']['output'];
  vendor?: Maybe<AccessPermission>;
  zone?: Maybe<AccessPermission>;
};

export type UserPermissionInput = {
  approval?: InputMaybe<AccessPermissionInput>;
  branch?: InputMaybe<AccessPermissionInput>;
  cash_sales?: InputMaybe<AccessPermissionInput>;
  company?: InputMaybe<AccessPermissionInput>;
  contact?: InputMaybe<AccessPermissionInput>;
  contact_export?: InputMaybe<AccessPermissionInput>;
  contact_setting?: InputMaybe<AccessPermissionInput>;
  customer?: InputMaybe<AccessPermissionInput>;
  customer_deposit?: InputMaybe<AccessPermissionInput>;
  delivery_order?: InputMaybe<AccessPermissionInput>;
  employee?: InputMaybe<AccessPermissionInput>;
  goods_adjust?: InputMaybe<AccessPermissionInput>;
  goods_issue?: InputMaybe<AccessPermissionInput>;
  goods_receive?: InputMaybe<AccessPermissionInput>;
  goods_return?: InputMaybe<AccessPermissionInput>;
  goods_transfer?: InputMaybe<AccessPermissionInput>;
  inventory?: InputMaybe<AccessPermissionInput>;
  inventory_export?: InputMaybe<AccessPermissionInput>;
  inventory_report?: InputMaybe<AccessPermissionInput>;
  inventory_setting?: InputMaybe<AccessPermissionInput>;
  is_custom: Scalars['Boolean']['input'];
  item?: InputMaybe<AccessPermissionInput>;
  logistic?: InputMaybe<AccessPermissionInput>;
  logistic_export?: InputMaybe<AccessPermissionInput>;
  logistic_report?: InputMaybe<AccessPermissionInput>;
  logistic_setting?: InputMaybe<AccessPermissionInput>;
  marketing?: InputMaybe<AccessPermissionInput>;
  marketing_export?: InputMaybe<AccessPermissionInput>;
  price_list?: InputMaybe<AccessPermissionInput>;
  promotion?: InputMaybe<AccessPermissionInput>;
  purchase?: InputMaybe<AccessPermissionInput>;
  purchase_export?: InputMaybe<AccessPermissionInput>;
  purchase_order?: InputMaybe<AccessPermissionInput>;
  purchase_report?: InputMaybe<AccessPermissionInput>;
  purchase_request?: InputMaybe<AccessPermissionInput>;
  purchase_return?: InputMaybe<AccessPermissionInput>;
  quotation?: InputMaybe<AccessPermissionInput>;
  role?: InputMaybe<AccessPermissionInput>;
  sales?: InputMaybe<AccessPermissionInput>;
  sales_export?: InputMaybe<AccessPermissionInput>;
  sales_invoice?: InputMaybe<AccessPermissionInput>;
  sales_order?: InputMaybe<AccessPermissionInput>;
  sales_report?: InputMaybe<AccessPermissionInput>;
  sales_return?: InputMaybe<AccessPermissionInput>;
  sales_setting?: InputMaybe<AccessPermissionInput>;
  setting?: InputMaybe<AccessPermissionInput>;
  user_account?: InputMaybe<AccessPermissionInput>;
  user_export?: InputMaybe<AccessPermissionInput>;
  vendor?: InputMaybe<AccessPermissionInput>;
  zone?: InputMaybe<AccessPermissionInput>;
};

export type Warehouse = {
  __typename?: 'Warehouse';
  address?: Maybe<Scalars['Json']['output']>;
  branch: Branch;
  branch_id: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_consignment?: Maybe<Scalars['Boolean']['output']>;
  is_same_as_branch?: Maybe<Scalars['Boolean']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  unique_id: Scalars['String']['output'];
  user: User;
  user_id: Scalars['Int']['output'];
  warehouse_level_1_list: Array<WarehouseLevel1>;
};

export type WarehouseLevel1 = {
  __typename?: 'WarehouseLevel1';
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  warehouse: Warehouse;
  warehouse_level_2_list?: Maybe<Array<WarehouseLevel2>>;
};

export type WarehouseLevel2 = {
  __typename?: 'WarehouseLevel2';
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  warehouse_level_1: WarehouseLevel1;
  warehouse_level_3_list?: Maybe<Array<WarehouseLevel3>>;
};

export type WarehouseLevel3 = {
  __typename?: 'WarehouseLevel3';
  bin_location_list?: Maybe<Array<BinLocation>>;
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  warehouse_level_2: WarehouseLevel2;
};

export type WorkflowTemplate = {
  __typename?: 'WorkflowTemplate';
  approval_template_list?: Maybe<Array<ApprovalTemplate>>;
  document_type: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  main_status: Scalars['String']['output'];
  step_number: Scalars['Int']['output'];
  sub_status?: Maybe<Scalars['String']['output']>;
};

export enum UomConversionScalarField {
  BaseUomRate = 'base_uom_rate',
  Id = 'id',
  TargetUomRate = 'target_uom_rate'
}

export type PurchaseItemFindManyQueryVariables = Exact<{
  input?: InputMaybe<PurchaseItemFindManyInput>;
}>;


export type PurchaseItemFindManyQuery = { __typename?: 'Query', PurchaseItemFindMany?: Array<{ __typename?: 'PurchaseItem', id: number, unique_id: string, reference_unique_id: string, reference_document_type: PurchaseDocumentType, item_unique_id: string, item_sku_name: string, item_name: string, item_sku_desc?: string | null, item_img_url?: Array<string> | null, tracability: TraceAbilityEnum, barcode: string, qty: number, po_qty?: number | null, qty_ordered?: number | null, qty_received?: number | null, qty_issued?: number | null, uom_id: number, uom_name: string, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, pre_vat_amount?: number | null, stock_qty?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null, last_updated_date?: any | null, reference_line_item?: { __typename?: 'ReferencePurchaseLineItem', line_item_unique_id: string, line_item_document_type: string, line_item_document_unique_id: string } | null } | null> | null };

export type PurchaseOrderCreateMutationVariables = Exact<{
  input: PurchaseOrderCreateInput;
}>;


export type PurchaseOrderCreateMutation = { __typename?: 'Mutation', PurchaseOrderCreate: { __typename?: 'PurchaseOrder', id: number, unique_id: string, branch_id: number, reference_document_id?: string | null, reference_no?: string | null, created_date: any, last_updated_date?: any | null, issue_date?: any | null, expected_date?: any | null, within_date?: any | null, credit_day?: number | null, currency?: string | null, currency_display_name?: string | null, exchange_rate?: number | null, destination_warehouse_id?: number | null, related_user_list?: Array<any> | null, vendor_unique_id?: string | null, vendor_details?: any | null, delivery_address?: any | null, price_vat_type?: PriceVatType | null, pre_vat_amount?: number | null, additional_discount?: number | null, additional_discount_type?: AdditionalDiscountType | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, template_remark_id?: string | null, remark?: string | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, tag_id_list?: Array<number> | null, approval_step?: number | null, approver_list?: Array<any> | null, reviewer_list?: Array<any> | null, branch: { __typename?: 'Branch', id: number, unique_id: string, name: string, short_name: string, zone?: string | null, phone?: string | null, fax?: string | null, status: number, is_hq: boolean, created_date?: any | null, last_updated_date?: any | null, address: any, user_id_list: Array<number>, user_list?: Array<{ __typename?: 'BranchUser', id?: number | null, branch_id?: number | null, user_id?: number | null } | null> | null }, reference_document_list?: Array<{ __typename?: 'PurchaseReferenceDocument', document_id?: number | null, document_unique_id?: string | null, document_type?: PurchaseReferenceType | null }> | null, created_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, destination_warehouse?: { __typename?: 'Warehouse', id: number, branch_id: number, unique_id: string, name: string, user_id: number, description?: string | null, address?: any | null, is_same_as_branch?: boolean | null } | null, tag_list?: Array<{ __typename?: 'Tag', id: number, name: string, document_type: TagDocumentType }> | null, item_list?: Array<{ __typename?: 'PurchaseItem', id: number, unique_id: string, reference_unique_id: string, reference_document_type: PurchaseDocumentType, item_unique_id: string, item_sku_name: string, item_name: string, item_sku_desc?: string | null, item_img_url?: Array<string> | null, tracability: TraceAbilityEnum, barcode: string, qty: number, po_qty?: number | null, qty_ordered?: number | null, qty_received?: number | null, qty_issued?: number | null, uom_id: number, uom_name: string, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, pre_vat_amount?: number | null, stock_qty?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null, reference_line_item?: { __typename?: 'ReferencePurchaseLineItem', line_item_unique_id: string, line_item_document_type: string, line_item_document_unique_id: string } | null }> | null } };

export type PurchaseOrderDeleteMutationVariables = Exact<{
  uniqueInput: PurchaseOrderUniqueInput;
}>;


export type PurchaseOrderDeleteMutation = { __typename?: 'Mutation', PurchaseOrderDelete: { __typename?: 'PurchaseOrder', id: number, unique_id: string, branch_id: number, reference_document_id?: string | null, reference_no?: string | null, created_date: any, last_updated_date?: any | null, issue_date?: any | null, expected_date?: any | null, within_date?: any | null, credit_day?: number | null, currency?: string | null, destination_warehouse_id?: number | null, related_user_list?: Array<any> | null, vendor_unique_id?: string | null, vendor_details?: any | null, delivery_address?: any | null, price_vat_type?: PriceVatType | null, pre_vat_amount?: number | null, additional_discount?: number | null, additional_discount_type?: AdditionalDiscountType | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, template_remark_id?: string | null, remark?: string | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, tag_id_list?: Array<number> | null, approval_step?: number | null, approver_list?: Array<any> | null, reviewer_list?: Array<any> | null, branch: { __typename?: 'Branch', id: number, unique_id: string, name: string, short_name: string, zone?: string | null, phone?: string | null, fax?: string | null, status: number, is_hq: boolean, created_date?: any | null, last_updated_date?: any | null, address: any, user_id_list: Array<number>, user_list?: Array<{ __typename?: 'BranchUser', id?: number | null, branch_id?: number | null, user_id?: number | null } | null> | null }, reference_document_list?: Array<{ __typename?: 'PurchaseReferenceDocument', document_id?: number | null, document_unique_id?: string | null, document_type?: PurchaseReferenceType | null }> | null, created_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, destination_warehouse?: { __typename?: 'Warehouse', id: number, branch_id: number, unique_id: string, name: string, user_id: number, description?: string | null, address?: any | null, is_same_as_branch?: boolean | null } | null, tag_list?: Array<{ __typename?: 'Tag', id: number, name: string, document_type: TagDocumentType }> | null, item_list?: Array<{ __typename?: 'PurchaseItem', id: number, unique_id: string, reference_unique_id: string, reference_document_type: PurchaseDocumentType, item_unique_id: string, item_sku_name: string, item_name: string, item_sku_desc?: string | null, item_img_url?: Array<string> | null, tracability: TraceAbilityEnum, barcode: string, qty: number, po_qty?: number | null, qty_ordered?: number | null, qty_received?: number | null, qty_issued?: number | null, uom_id: number, uom_name: string, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, pre_vat_amount?: number | null, stock_qty?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null, reference_line_item?: { __typename?: 'ReferencePurchaseLineItem', line_item_unique_id: string, line_item_document_type: string, line_item_document_unique_id: string } | null }> | null } };

export type PurchaseOrderFindUniqueQueryVariables = Exact<{
  uniqueInput: PurchaseOrderUniqueInput;
}>;


export type PurchaseOrderFindUniqueQuery = { __typename?: 'Query', PurchaseOrderFindUnique: { __typename?: 'PurchaseOrder', id: number, unique_id: string, branch_id: number, reference_document_id?: string | null, reference_no?: string | null, created_date: any, last_updated_date?: any | null, issue_date?: any | null, expected_date?: any | null, within_date?: any | null, credit_day?: number | null, currency?: string | null, currency_display_name?: string | null, exchange_rate?: number | null, destination_warehouse_id?: number | null, related_user_list?: Array<any> | null, vendor_unique_id?: string | null, vendor_details?: any | null, delivery_address?: any | null, price_vat_type?: PriceVatType | null, pre_vat_amount?: number | null, additional_discount?: number | null, additional_discount_type?: AdditionalDiscountType | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, template_remark_id?: string | null, remark?: string | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, tag_id_list?: Array<number> | null, approval_step?: number | null, approver_list?: Array<any> | null, reviewer_list?: Array<any> | null, branch: { __typename?: 'Branch', id: number, unique_id: string, name: string, short_name: string, zone?: string | null, phone?: string | null, fax?: string | null, status: number, is_hq: boolean, created_date?: any | null, last_updated_date?: any | null, address: any, user_id_list: Array<number>, user_list?: Array<{ __typename?: 'BranchUser', id?: number | null, branch_id?: number | null, user_id?: number | null } | null> | null }, reference_document_list?: Array<{ __typename?: 'PurchaseReferenceDocument', document_id?: number | null, document_unique_id?: string | null, document_type?: PurchaseReferenceType | null }> | null, created_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, destination_warehouse?: { __typename?: 'Warehouse', id: number, branch_id: number, unique_id: string, name: string, user_id: number, description?: string | null, address?: any | null, is_same_as_branch?: boolean | null } | null, tag_list?: Array<{ __typename?: 'Tag', id: number, name: string, document_type: TagDocumentType }> | null, item_list?: Array<{ __typename?: 'PurchaseItem', id: number, unique_id: string, reference_unique_id: string, reference_document_type: PurchaseDocumentType, item_unique_id: string, item_sku_name: string, item_name: string, item_sku_desc?: string | null, item_img_url?: Array<string> | null, tracability: TraceAbilityEnum, barcode: string, qty: number, po_qty?: number | null, qty_ordered?: number | null, qty_received?: number | null, qty_issued?: number | null, uom_id: number, uom_name: string, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, pre_vat_amount?: number | null, stock_qty?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null, reference_line_item?: { __typename?: 'ReferencePurchaseLineItem', line_item_unique_id: string, line_item_document_type: string, line_item_document_unique_id: string } | null }> | null } };

export type PurchaseOrderUniqueIdQueryQueryVariables = Exact<{
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
}>;


export type PurchaseOrderUniqueIdQueryQuery = { __typename?: 'Query', PurchaseOrderViewsAggrid?: { __typename?: 'PurchaseOrderViewAggridOutput', results: Array<{ __typename?: 'PurchaseOrderView', id: number, unique_id: string }> } | null };

export type PurchaseOrderUpdateMutationVariables = Exact<{
  uniqueInput: PurchaseOrderUniqueInput;
  input: PurchaseOrderUpdateInput;
}>;


export type PurchaseOrderUpdateMutation = { __typename?: 'Mutation', PurchaseOrderUpdate: { __typename?: 'PurchaseOrder', id: number, unique_id: string, branch_id: number, reference_document_id?: string | null, reference_no?: string | null, created_date: any, last_updated_date?: any | null, issue_date?: any | null, expected_date?: any | null, within_date?: any | null, credit_day?: number | null, currency?: string | null, currency_display_name?: string | null, exchange_rate?: number | null, destination_warehouse_id?: number | null, related_user_list?: Array<any> | null, vendor_unique_id?: string | null, vendor_details?: any | null, delivery_address?: any | null, price_vat_type?: PriceVatType | null, pre_vat_amount?: number | null, additional_discount?: number | null, additional_discount_type?: AdditionalDiscountType | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, template_remark_id?: string | null, remark?: string | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, tag_id_list?: Array<number> | null, approval_step?: number | null, approver_list?: Array<any> | null, reviewer_list?: Array<any> | null, branch: { __typename?: 'Branch', id: number, unique_id: string, name: string, short_name: string, zone?: string | null, phone?: string | null, fax?: string | null, status: number, is_hq: boolean, created_date?: any | null, last_updated_date?: any | null, address: any, user_id_list: Array<number>, user_list?: Array<{ __typename?: 'BranchUser', id?: number | null, branch_id?: number | null, user_id?: number | null } | null> | null }, reference_document_list?: Array<{ __typename?: 'PurchaseReferenceDocument', document_id?: number | null, document_unique_id?: string | null, document_type?: PurchaseReferenceType | null }> | null, created_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, destination_warehouse?: { __typename?: 'Warehouse', id: number, branch_id: number, unique_id: string, name: string, user_id: number, description?: string | null, address?: any | null, is_same_as_branch?: boolean | null } | null, tag_list?: Array<{ __typename?: 'Tag', id: number, name: string, document_type: TagDocumentType }> | null, item_list?: Array<{ __typename?: 'PurchaseItem', id: number, unique_id: string, reference_unique_id: string, reference_document_type: PurchaseDocumentType, item_unique_id: string, item_sku_name: string, item_name: string, item_sku_desc?: string | null, item_img_url?: Array<string> | null, tracability: TraceAbilityEnum, barcode: string, qty: number, po_qty?: number | null, qty_ordered?: number | null, qty_received?: number | null, qty_issued?: number | null, uom_id: number, uom_name: string, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, pre_vat_amount?: number | null, stock_qty?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null, reference_line_item?: { __typename?: 'ReferencePurchaseLineItem', line_item_unique_id: string, line_item_document_type: string, line_item_document_unique_id: string } | null }> | null } };

export type PurchaseRequestCreateMutationVariables = Exact<{
  input: PurchaseRequestCreateInput;
}>;


export type PurchaseRequestCreateMutation = { __typename?: 'Mutation', PurchaseRequestCreate: { __typename?: 'PurchaseRequest', id: number, unique_id: string, branch_id: number, reference_no?: string | null, created_date: any, last_updated_date?: any | null, issue_date?: any | null, expected_date?: any | null, within_date?: any | null, related_user_list?: Array<any> | null, requester?: any | null, delivery_address?: any | null, template_remark_id?: string | null, remark?: string | null, accepted_remark?: string | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, tag_id_list?: Array<number> | null, attachment_list?: Array<any> | null, approval_step?: number | null, approver_list?: Array<any> | null, reviewer_list?: Array<any> | null, branch: { __typename?: 'Branch', id: number, unique_id: string, name: string, short_name: string, zone?: string | null, phone?: string | null, fax?: string | null, status: number, is_hq: boolean, created_date?: any | null, last_updated_date?: any | null, address: any, user_id_list: Array<number>, user_list?: Array<{ __typename?: 'BranchUser', id?: number | null, branch_id?: number | null, user_id?: number | null, user?: { __typename?: 'User', id: number, unique_id: string, email: string, original_branch: number, img_url?: Array<string | null> | null, title_name?: string | null, first_name: string, last_name: string, nick_name?: string | null, gender?: string | null, phone?: string | null, department?: string | null, position?: string | null, employee_type?: string | null, company_name?: string | null, is_sales_employee?: boolean | null, status: number, inactive_date?: any | null, start_date?: any | null, created_date?: any | null, last_updated_date?: any | null, last_login_branch?: number | null, remark_status?: string | null, original_branch_object?: { __typename?: 'Branch', id: number, unique_id: string, name: string } | null } | null } | null> | null }, reference_document_list?: Array<{ __typename?: 'PurchaseReferenceDocument', document_id?: number | null, document_unique_id?: string | null, document_type?: PurchaseReferenceType | null }> | null, created_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, tag_list?: Array<{ __typename?: 'Tag', id: number, name: string, document_type: TagDocumentType }> | null, item_list?: Array<{ __typename?: 'PurchaseItem', id: number, unique_id: string, reference_unique_id: string, reference_document_type: PurchaseDocumentType, item_unique_id: string, item_sku_name: string, item_name: string, item_sku_desc?: string | null, item_img_url?: Array<string> | null, tracability: TraceAbilityEnum, barcode: string, qty: number, po_qty?: number | null, qty_ordered?: number | null, qty_received?: number | null, qty_issued?: number | null, uom_id: number, uom_name: string, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, pre_vat_amount?: number | null, stock_qty?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null, reference_line_item?: { __typename?: 'ReferencePurchaseLineItem', line_item_unique_id: string, line_item_document_type: string, line_item_document_unique_id: string } | null }> | null } };

export type PurchaseRequestDeleteMutationVariables = Exact<{
  uniqueInput: PurchaseRequestUniqueInput;
}>;


export type PurchaseRequestDeleteMutation = { __typename?: 'Mutation', PurchaseRequestDelete: { __typename?: 'PurchaseRequest', id: number, unique_id: string, branch_id: number, reference_no?: string | null, created_date: any, last_updated_date?: any | null, issue_date?: any | null, expected_date?: any | null, within_date?: any | null, related_user_list?: Array<any> | null, requester?: any | null, delivery_address?: any | null, template_remark_id?: string | null, remark?: string | null, accepted_remark?: string | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, tag_id_list?: Array<number> | null, attachment_list?: Array<any> | null, approval_step?: number | null, approver_list?: Array<any> | null, reviewer_list?: Array<any> | null, branch: { __typename?: 'Branch', id: number, unique_id: string, name: string, short_name: string, zone?: string | null, phone?: string | null, fax?: string | null, status: number, is_hq: boolean, created_date?: any | null, last_updated_date?: any | null, address: any, user_id_list: Array<number>, user_list?: Array<{ __typename?: 'BranchUser', id?: number | null, branch_id?: number | null, user_id?: number | null, user?: { __typename?: 'User', id: number, unique_id: string, email: string, original_branch: number, img_url?: Array<string | null> | null, title_name?: string | null, first_name: string, last_name: string, nick_name?: string | null, gender?: string | null, phone?: string | null, department?: string | null, position?: string | null, employee_type?: string | null, company_name?: string | null, is_sales_employee?: boolean | null, status: number, inactive_date?: any | null, start_date?: any | null, created_date?: any | null, last_updated_date?: any | null, last_login_branch?: number | null, remark_status?: string | null, original_branch_object?: { __typename?: 'Branch', id: number, unique_id: string, name: string } | null } | null } | null> | null }, reference_document_list?: Array<{ __typename?: 'PurchaseReferenceDocument', document_id?: number | null, document_unique_id?: string | null, document_type?: PurchaseReferenceType | null }> | null, created_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, tag_list?: Array<{ __typename?: 'Tag', id: number, name: string, document_type: TagDocumentType }> | null, item_list?: Array<{ __typename?: 'PurchaseItem', id: number, unique_id: string, reference_unique_id: string, reference_document_type: PurchaseDocumentType, item_unique_id: string, item_sku_name: string, item_name: string, item_sku_desc?: string | null, item_img_url?: Array<string> | null, tracability: TraceAbilityEnum, barcode: string, qty: number, po_qty?: number | null, qty_ordered?: number | null, qty_received?: number | null, qty_issued?: number | null, uom_id: number, uom_name: string, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, pre_vat_amount?: number | null, stock_qty?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null, reference_line_item?: { __typename?: 'ReferencePurchaseLineItem', line_item_unique_id: string, line_item_document_type: string, line_item_document_unique_id: string } | null }> | null } };

export type PurchaseRequestFindUniqueQueryVariables = Exact<{
  uniqueInput: PurchaseRequestUniqueInput;
}>;


export type PurchaseRequestFindUniqueQuery = { __typename?: 'Query', PurchaseRequestFindUnique: { __typename?: 'PurchaseRequest', id: number, unique_id: string, branch_id: number, reference_no?: string | null, created_date: any, last_updated_date?: any | null, issue_date?: any | null, expected_date?: any | null, within_date?: any | null, related_user_list?: Array<any> | null, requester?: any | null, delivery_address?: any | null, template_remark_id?: string | null, remark?: string | null, accepted_remark?: string | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, tag_id_list?: Array<number> | null, attachment_list?: Array<any> | null, approval_step?: number | null, approver_list?: Array<any> | null, reviewer_list?: Array<any> | null, branch: { __typename?: 'Branch', id: number, unique_id: string, name: string, short_name: string, zone?: string | null, phone?: string | null, fax?: string | null, status: number, is_hq: boolean, created_date?: any | null, last_updated_date?: any | null, address: any, user_id_list: Array<number>, user_list?: Array<{ __typename?: 'BranchUser', id?: number | null, branch_id?: number | null, user_id?: number | null, user?: { __typename?: 'User', id: number, unique_id: string, email: string, original_branch: number, img_url?: Array<string | null> | null, title_name?: string | null, first_name: string, last_name: string, nick_name?: string | null, gender?: string | null, phone?: string | null, department?: string | null, position?: string | null, employee_type?: string | null, company_name?: string | null, is_sales_employee?: boolean | null, status: number, inactive_date?: any | null, start_date?: any | null, created_date?: any | null, last_updated_date?: any | null, last_login_branch?: number | null, remark_status?: string | null, original_branch_object?: { __typename?: 'Branch', id: number, unique_id: string, name: string } | null } | null } | null> | null }, reference_document_list?: Array<{ __typename?: 'PurchaseReferenceDocument', document_id?: number | null, document_unique_id?: string | null, document_type?: PurchaseReferenceType | null }> | null, created_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, tag_list?: Array<{ __typename?: 'Tag', id: number, name: string, document_type: TagDocumentType }> | null, item_list?: Array<{ __typename?: 'PurchaseItem', id: number, unique_id: string, reference_unique_id: string, reference_document_type: PurchaseDocumentType, item_unique_id: string, item_sku_name: string, item_name: string, item_sku_desc?: string | null, item_img_url?: Array<string> | null, tracability: TraceAbilityEnum, barcode: string, qty: number, po_qty?: number | null, qty_ordered?: number | null, qty_received?: number | null, qty_issued?: number | null, uom_id: number, uom_name: string, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, pre_vat_amount?: number | null, stock_qty?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null, reference_line_item?: { __typename?: 'ReferencePurchaseLineItem', line_item_unique_id: string, line_item_document_type: string, line_item_document_unique_id: string } | null }> | null } };

export type PurchaseRequestUpdateMutationVariables = Exact<{
  uniqueInput: PurchaseRequestUniqueInput;
  input: PurchaseRequestUpdateInput;
}>;


export type PurchaseRequestUpdateMutation = { __typename?: 'Mutation', PurchaseRequestUpdate: { __typename?: 'PurchaseRequest', id: number, unique_id: string, branch_id: number, reference_no?: string | null, created_date: any, last_updated_date?: any | null, issue_date?: any | null, expected_date?: any | null, within_date?: any | null, related_user_list?: Array<any> | null, requester?: any | null, delivery_address?: any | null, template_remark_id?: string | null, remark?: string | null, accepted_remark?: string | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, tag_id_list?: Array<number> | null, attachment_list?: Array<any> | null, approval_step?: number | null, approver_list?: Array<any> | null, reviewer_list?: Array<any> | null, branch: { __typename?: 'Branch', id: number, unique_id: string, name: string, short_name: string, zone?: string | null, phone?: string | null, fax?: string | null, status: number, is_hq: boolean, created_date?: any | null, last_updated_date?: any | null, address: any, user_id_list: Array<number>, user_list?: Array<{ __typename?: 'BranchUser', id?: number | null, branch_id?: number | null, user_id?: number | null, user?: { __typename?: 'User', id: number, unique_id: string, email: string, original_branch: number, img_url?: Array<string | null> | null, title_name?: string | null, first_name: string, last_name: string, nick_name?: string | null, gender?: string | null, phone?: string | null, department?: string | null, position?: string | null, employee_type?: string | null, company_name?: string | null, is_sales_employee?: boolean | null, status: number, inactive_date?: any | null, start_date?: any | null, created_date?: any | null, last_updated_date?: any | null, last_login_branch?: number | null, remark_status?: string | null, original_branch_object?: { __typename?: 'Branch', id: number, unique_id: string, name: string } | null } | null } | null> | null }, reference_document_list?: Array<{ __typename?: 'PurchaseReferenceDocument', document_id?: number | null, document_unique_id?: string | null, document_type?: PurchaseReferenceType | null }> | null, created_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, tag_list?: Array<{ __typename?: 'Tag', id: number, name: string, document_type: TagDocumentType }> | null, item_list?: Array<{ __typename?: 'PurchaseItem', id: number, unique_id: string, reference_unique_id: string, reference_document_type: PurchaseDocumentType, item_unique_id: string, item_sku_name: string, item_name: string, item_sku_desc?: string | null, item_img_url?: Array<string> | null, tracability: TraceAbilityEnum, barcode: string, qty: number, po_qty?: number | null, qty_ordered?: number | null, qty_received?: number | null, qty_issued?: number | null, uom_id: number, uom_name: string, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, pre_vat_amount?: number | null, stock_qty?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null, reference_line_item?: { __typename?: 'ReferencePurchaseLineItem', line_item_unique_id: string, line_item_document_type: string, line_item_document_unique_id: string } | null }> | null } };

export type PurchaseRequestsFindAllQueryVariables = Exact<{ [key: string]: never; }>;


export type PurchaseRequestsFindAllQuery = { __typename?: 'Query', PurchaseRequestsFindAll?: Array<{ __typename?: 'PurchaseRequest', id: number, unique_id: string, branch_id: number, reference_no?: string | null, created_date: any, last_updated_date?: any | null, issue_date?: any | null, expected_date?: any | null, within_date?: any | null, related_user_list?: Array<any> | null, requester?: any | null, delivery_address?: any | null, template_remark_id?: string | null, remark?: string | null, accepted_remark?: string | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, tag_id_list?: Array<number> | null, attachment_list?: Array<any> | null, approval_step?: number | null, approver_list?: Array<any> | null, reviewer_list?: Array<any> | null, branch: { __typename?: 'Branch', id: number, unique_id: string, name: string, short_name: string, zone?: string | null, phone?: string | null, fax?: string | null, status: number, is_hq: boolean, created_date?: any | null, last_updated_date?: any | null, address: any, user_id_list: Array<number>, user_list?: Array<{ __typename?: 'BranchUser', id?: number | null, branch_id?: number | null, user_id?: number | null, user?: { __typename?: 'User', id: number, unique_id: string, email: string, original_branch: number, img_url?: Array<string | null> | null, title_name?: string | null, first_name: string, last_name: string, nick_name?: string | null, gender?: string | null, phone?: string | null, department?: string | null, position?: string | null, employee_type?: string | null, company_name?: string | null, is_sales_employee?: boolean | null, status: number, inactive_date?: any | null, start_date?: any | null, created_date?: any | null, last_updated_date?: any | null, last_login_branch?: number | null, remark_status?: string | null, original_branch_object?: { __typename?: 'Branch', id: number, unique_id: string, name: string } | null } | null } | null> | null }, reference_document_list?: Array<{ __typename?: 'PurchaseReferenceDocument', document_id?: number | null, document_unique_id?: string | null, document_type?: PurchaseReferenceType | null }> | null, created_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, tag_list?: Array<{ __typename?: 'Tag', id: number, name: string, document_type: TagDocumentType }> | null, item_list?: Array<{ __typename?: 'PurchaseItem', id: number, unique_id: string, reference_unique_id: string, reference_document_type: PurchaseDocumentType, item_unique_id: string, item_sku_name: string, item_name: string, item_sku_desc?: string | null, item_img_url?: Array<string> | null, tracability: TraceAbilityEnum, barcode: string, qty: number, po_qty?: number | null, qty_ordered?: number | null, qty_received?: number | null, qty_issued?: number | null, uom_id: number, uom_name: string, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, pre_vat_amount?: number | null, stock_qty?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null, reference_line_item?: { __typename?: 'ReferencePurchaseLineItem', line_item_unique_id: string, line_item_document_type: string, line_item_document_unique_id: string } | null }> | null }> | null };

export type PurchaseReturnCreateMutationVariables = Exact<{
  input: PurchaseReturnCreateInput;
}>;


export type PurchaseReturnCreateMutation = { __typename?: 'Mutation', PurchaseReturnCreate: { __typename?: 'PurchaseReturn', id: number, unique_id: string, branch_id: number, reference_no?: string | null, created_date: any, last_updated_date?: any | null, issue_date?: any | null, delivery_date?: any | null, credit_day?: number | null, related_user_list?: Array<any> | null, reason_to_return?: string | null, vendor_unique_id?: string | null, vendor_details?: any | null, price_vat_type?: PriceVatType | null, currency?: string | null, currency_display_name?: string | null, pre_vat_amount?: number | null, additional_discount?: number | null, additional_discount_type?: AdditionalDiscountType | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, template_remark_id?: string | null, remark?: string | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, tag_id_list?: Array<number> | null, approval_step?: number | null, approver_list?: Array<any> | null, reviewer_list?: Array<any> | null, branch: { __typename?: 'Branch', id: number, unique_id: string, name: string, short_name: string, zone?: string | null, phone?: string | null, fax?: string | null, status: number, is_hq: boolean, created_date?: any | null, last_updated_date?: any | null, address: any, user_id_list: Array<number>, user_list?: Array<{ __typename?: 'BranchUser', id?: number | null, branch_id?: number | null, user_id?: number | null } | null> | null }, reference_document_list?: Array<{ __typename?: 'PurchaseReferenceDocument', document_id?: number | null, document_unique_id?: string | null, document_type?: PurchaseReferenceType | null }> | null, created_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, item_list?: Array<{ __typename?: 'PurchaseItem', id: number, unique_id: string, reference_unique_id: string, reference_document_type: PurchaseDocumentType, item_unique_id: string, item_sku_name: string, item_name: string, item_sku_desc?: string | null, item_img_url?: Array<string> | null, tracability: TraceAbilityEnum, barcode: string, qty: number, po_qty?: number | null, qty_ordered?: number | null, qty_received?: number | null, qty_issued?: number | null, uom_id: number, uom_name: string, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, pre_vat_amount?: number | null, stock_qty?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null, reference_line_item?: { __typename?: 'ReferencePurchaseLineItem', line_item_unique_id: string, line_item_document_type: string, line_item_document_unique_id: string } | null }> | null, tag_list?: Array<{ __typename?: 'Tag', id: number, name: string, document_type: TagDocumentType }> | null } };

export type PurchaseReturnFindUniqueQueryVariables = Exact<{
  uniqueInput: PurchaseReturnUniqueInput;
}>;


export type PurchaseReturnFindUniqueQuery = { __typename?: 'Query', PurchaseReturnFindUnique: { __typename?: 'PurchaseReturn', id: number, unique_id: string, branch_id: number, reference_no?: string | null, created_date: any, last_updated_date?: any | null, issue_date?: any | null, delivery_date?: any | null, credit_day?: number | null, related_user_list?: Array<any> | null, reason_to_return?: string | null, vendor_unique_id?: string | null, vendor_details?: any | null, price_vat_type?: PriceVatType | null, currency?: string | null, currency_display_name?: string | null, pre_vat_amount?: number | null, additional_discount?: number | null, additional_discount_type?: AdditionalDiscountType | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, template_remark_id?: string | null, remark?: string | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, tag_id_list?: Array<number> | null, approval_step?: number | null, approver_list?: Array<any> | null, reviewer_list?: Array<any> | null, branch: { __typename?: 'Branch', id: number, unique_id: string, name: string, short_name: string, zone?: string | null, phone?: string | null, fax?: string | null, status: number, is_hq: boolean, created_date?: any | null, last_updated_date?: any | null, address: any, user_id_list: Array<number>, user_list?: Array<{ __typename?: 'BranchUser', id?: number | null, branch_id?: number | null, user_id?: number | null } | null> | null }, reference_document_list?: Array<{ __typename?: 'PurchaseReferenceDocument', document_id?: number | null, document_unique_id?: string | null, document_type?: PurchaseReferenceType | null }> | null, created_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, item_list?: Array<{ __typename?: 'PurchaseItem', id: number, unique_id: string, reference_unique_id: string, reference_document_type: PurchaseDocumentType, item_unique_id: string, item_sku_name: string, item_name: string, item_sku_desc?: string | null, item_img_url?: Array<string> | null, tracability: TraceAbilityEnum, barcode: string, qty: number, po_qty?: number | null, qty_ordered?: number | null, qty_received?: number | null, qty_issued?: number | null, uom_id: number, uom_name: string, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, pre_vat_amount?: number | null, stock_qty?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null, reference_line_item?: { __typename?: 'ReferencePurchaseLineItem', line_item_unique_id: string, line_item_document_type: string, line_item_document_unique_id: string } | null }> | null, tag_list?: Array<{ __typename?: 'Tag', id: number, name: string, document_type: TagDocumentType }> | null } };

export type PurchaseReturnUniqueIdQueryQueryVariables = Exact<{
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
}>;


export type PurchaseReturnUniqueIdQueryQuery = { __typename?: 'Query', PurchaseReturnViewsAggrid?: { __typename?: 'PurchaseReturnViewAggridOutput', results: Array<{ __typename?: 'PurchaseReturnView', id: number, unique_id: string, item_list?: Array<{ __typename?: 'PurchaseItem', qty: number, qty_issued?: number | null }> | null }> } | null };

export type PurchaseReturnUpdateMutationVariables = Exact<{
  uniqueInput: PurchaseReturnUniqueInput;
  input: PurchaseReturnUpdateInput;
}>;


export type PurchaseReturnUpdateMutation = { __typename?: 'Mutation', PurchaseReturnUpdate: { __typename?: 'PurchaseReturn', id: number, unique_id: string, branch_id: number, reference_no?: string | null, created_date: any, last_updated_date?: any | null, issue_date?: any | null, delivery_date?: any | null, credit_day?: number | null, related_user_list?: Array<any> | null, reason_to_return?: string | null, vendor_unique_id?: string | null, vendor_details?: any | null, price_vat_type?: PriceVatType | null, currency?: string | null, currency_display_name?: string | null, pre_vat_amount?: number | null, additional_discount?: number | null, additional_discount_type?: AdditionalDiscountType | null, post_discount_amount?: number | null, vat_exempted_amount?: number | null, vat_0_percent_amount?: number | null, vat_7_percent_amount?: number | null, vat_amount?: number | null, net_amount?: number | null, withholding_tax_amount?: number | null, total_amount?: number | null, template_remark_id?: string | null, remark?: string | null, main_status?: string | null, sub_status?: string | null, flag_status?: Array<string> | null, aggrid_status?: string | null, tag_id_list?: Array<number> | null, approval_step?: number | null, approver_list?: Array<any> | null, reviewer_list?: Array<any> | null, branch: { __typename?: 'Branch', id: number, unique_id: string, name: string, short_name: string, zone?: string | null, phone?: string | null, fax?: string | null, status: number, is_hq: boolean, created_date?: any | null, last_updated_date?: any | null, address: any, user_id_list: Array<number>, user_list?: Array<{ __typename?: 'BranchUser', id?: number | null, branch_id?: number | null, user_id?: number | null } | null> | null }, reference_document_list?: Array<{ __typename?: 'PurchaseReferenceDocument', document_id?: number | null, document_unique_id?: string | null, document_type?: PurchaseReferenceType | null }> | null, created_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, last_updated_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null, item_list?: Array<{ __typename?: 'PurchaseItem', id: number, unique_id: string, reference_unique_id: string, reference_document_type: PurchaseDocumentType, item_unique_id: string, item_sku_name: string, item_name: string, item_sku_desc?: string | null, item_img_url?: Array<string> | null, tracability: TraceAbilityEnum, barcode: string, qty: number, po_qty?: number | null, qty_ordered?: number | null, qty_received?: number | null, qty_issued?: number | null, uom_id: number, uom_name: string, price_per_unit?: number | null, discount?: number | null, vat_percentage?: string | null, pre_vat_amount?: number | null, stock_qty?: number | null, withholding_tax_type?: string | null, withholding_tax_value?: number | null, remark?: string | null, reference_line_item?: { __typename?: 'ReferencePurchaseLineItem', line_item_unique_id: string, line_item_document_type: string, line_item_document_unique_id: string } | null }> | null, tag_list?: Array<{ __typename?: 'Tag', id: number, name: string, document_type: TagDocumentType }> | null } };

export type PurchaseUniqueIdGenerateQueryVariables = Exact<{
  modelType: PurchaseModelType;
}>;


export type PurchaseUniqueIdGenerateQuery = { __typename?: 'Query', UniqueIdGenerate: string };


export const PurchaseItemFindManyDocument = `
    query PurchaseItemFindMany($input: PurchaseItemFindManyInput) {
  PurchaseItemFindMany(input: $input) {
    id
    unique_id
    reference_line_item {
      line_item_unique_id
      line_item_document_type
      line_item_document_unique_id
    }
    reference_unique_id
    reference_document_type
    item_unique_id
    item_sku_name
    item_name
    item_sku_desc
    item_img_url
    tracability
    barcode
    qty
    po_qty
    qty_ordered
    qty_received
    qty_issued
    uom_id
    uom_name
    price_per_unit
    discount
    vat_percentage
    pre_vat_amount
    stock_qty
    withholding_tax_type
    withholding_tax_value
    remark
    last_updated_date
  }
}
    `;
export const usePurchaseItemFindManyQuery = <
      TData = PurchaseItemFindManyQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: PurchaseItemFindManyQueryVariables,
      options?: UseQueryOptions<PurchaseItemFindManyQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<PurchaseItemFindManyQuery, TError, TData>(
      variables === undefined ? ['PurchaseItemFindMany'] : ['PurchaseItemFindMany', variables],
      fetcher<PurchaseItemFindManyQuery, PurchaseItemFindManyQueryVariables>(client, PurchaseItemFindManyDocument, variables, headers),
      options
    );
export const PurchaseOrderCreateDocument = `
    mutation PurchaseOrderCreate($input: PurchaseOrderCreateInput!) {
  PurchaseOrderCreate(input: $input) {
    id
    unique_id
    branch_id
    branch {
      id
      unique_id
      name
      short_name
      zone
      phone
      fax
      status
      is_hq
      created_date
      last_updated_date
      address
      user_id_list
      user_list {
        id
        branch_id
        user_id
      }
    }
    reference_document_list {
      document_id
      document_unique_id
      document_type
    }
    reference_document_id
    reference_no
    created_date
    created_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    issue_date
    expected_date
    within_date
    credit_day
    currency
    currency_display_name
    exchange_rate
    destination_warehouse_id
    destination_warehouse {
      id
      branch_id
      unique_id
      name
      user_id
      description
      address
      is_same_as_branch
    }
    related_user_list
    vendor_unique_id
    vendor_details
    delivery_address
    price_vat_type
    pre_vat_amount
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    template_remark_id
    remark
    main_status
    sub_status
    flag_status
    aggrid_status
    tag_id_list
    tag_list {
      id
      name
      document_type
    }
    item_list {
      id
      unique_id
      reference_unique_id
      reference_document_type
      reference_line_item {
        line_item_unique_id
        line_item_document_type
        line_item_document_unique_id
      }
      item_unique_id
      item_sku_name
      item_name
      item_sku_desc
      item_img_url
      tracability
      barcode
      qty
      po_qty
      qty_ordered
      qty_received
      qty_issued
      uom_id
      uom_name
      price_per_unit
      discount
      vat_percentage
      pre_vat_amount
      stock_qty
      withholding_tax_type
      withholding_tax_value
      remark
    }
    approval_step
    approver_list
    reviewer_list
  }
}
    `;
export const usePurchaseOrderCreateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<PurchaseOrderCreateMutation, TError, PurchaseOrderCreateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<PurchaseOrderCreateMutation, TError, PurchaseOrderCreateMutationVariables, TContext>(
      ['PurchaseOrderCreate'],
      (variables?: PurchaseOrderCreateMutationVariables) => fetcher<PurchaseOrderCreateMutation, PurchaseOrderCreateMutationVariables>(client, PurchaseOrderCreateDocument, variables, headers)(),
      options
    );
export const PurchaseOrderDeleteDocument = `
    mutation PurchaseOrderDelete($uniqueInput: PurchaseOrderUniqueInput!) {
  PurchaseOrderDelete(uniqueInput: $uniqueInput) {
    id
    unique_id
    branch_id
    branch {
      id
      unique_id
      name
      short_name
      zone
      phone
      fax
      status
      is_hq
      created_date
      last_updated_date
      address
      user_id_list
      user_list {
        id
        branch_id
        user_id
      }
    }
    reference_document_list {
      document_id
      document_unique_id
      document_type
    }
    reference_document_id
    reference_no
    created_date
    created_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    issue_date
    expected_date
    within_date
    credit_day
    currency
    destination_warehouse_id
    destination_warehouse {
      id
      branch_id
      unique_id
      name
      user_id
      description
      address
      is_same_as_branch
    }
    related_user_list
    vendor_unique_id
    vendor_details
    delivery_address
    price_vat_type
    pre_vat_amount
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    template_remark_id
    remark
    main_status
    sub_status
    flag_status
    aggrid_status
    tag_id_list
    tag_list {
      id
      name
      document_type
    }
    item_list {
      id
      unique_id
      reference_unique_id
      reference_document_type
      reference_line_item {
        line_item_unique_id
        line_item_document_type
        line_item_document_unique_id
      }
      item_unique_id
      item_sku_name
      item_name
      item_sku_desc
      item_img_url
      tracability
      barcode
      qty
      po_qty
      qty_ordered
      qty_received
      qty_issued
      uom_id
      uom_name
      price_per_unit
      discount
      vat_percentage
      pre_vat_amount
      stock_qty
      withholding_tax_type
      withholding_tax_value
      remark
    }
    approval_step
    approver_list
    reviewer_list
  }
}
    `;
export const usePurchaseOrderDeleteMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<PurchaseOrderDeleteMutation, TError, PurchaseOrderDeleteMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<PurchaseOrderDeleteMutation, TError, PurchaseOrderDeleteMutationVariables, TContext>(
      ['PurchaseOrderDelete'],
      (variables?: PurchaseOrderDeleteMutationVariables) => fetcher<PurchaseOrderDeleteMutation, PurchaseOrderDeleteMutationVariables>(client, PurchaseOrderDeleteDocument, variables, headers)(),
      options
    );
export const PurchaseOrderFindUniqueDocument = `
    query PurchaseOrderFindUnique($uniqueInput: PurchaseOrderUniqueInput!) {
  PurchaseOrderFindUnique(uniqueInput: $uniqueInput) {
    id
    unique_id
    branch_id
    branch {
      id
      unique_id
      name
      short_name
      zone
      phone
      fax
      status
      is_hq
      created_date
      last_updated_date
      address
      user_id_list
      user_list {
        id
        branch_id
        user_id
      }
    }
    reference_document_list {
      document_id
      document_unique_id
      document_type
    }
    reference_document_id
    reference_no
    created_date
    created_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    issue_date
    expected_date
    within_date
    credit_day
    currency
    currency_display_name
    exchange_rate
    destination_warehouse_id
    destination_warehouse {
      id
      branch_id
      unique_id
      name
      user_id
      description
      address
      is_same_as_branch
    }
    related_user_list
    vendor_unique_id
    vendor_details
    delivery_address
    price_vat_type
    pre_vat_amount
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    template_remark_id
    remark
    main_status
    sub_status
    flag_status
    aggrid_status
    tag_id_list
    tag_list {
      id
      name
      document_type
    }
    item_list {
      id
      unique_id
      reference_unique_id
      reference_document_type
      reference_line_item {
        line_item_unique_id
        line_item_document_type
        line_item_document_unique_id
      }
      item_unique_id
      item_sku_name
      item_name
      item_sku_desc
      item_img_url
      tracability
      barcode
      qty
      po_qty
      qty_ordered
      qty_received
      qty_issued
      uom_id
      uom_name
      price_per_unit
      discount
      vat_percentage
      pre_vat_amount
      stock_qty
      withholding_tax_type
      withholding_tax_value
      remark
    }
    approval_step
    approver_list
    reviewer_list
  }
}
    `;
export const usePurchaseOrderFindUniqueQuery = <
      TData = PurchaseOrderFindUniqueQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: PurchaseOrderFindUniqueQueryVariables,
      options?: UseQueryOptions<PurchaseOrderFindUniqueQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<PurchaseOrderFindUniqueQuery, TError, TData>(
      ['PurchaseOrderFindUnique', variables],
      fetcher<PurchaseOrderFindUniqueQuery, PurchaseOrderFindUniqueQueryVariables>(client, PurchaseOrderFindUniqueDocument, variables, headers),
      options
    );
export const PurchaseOrderUniqueIdQueryDocument = `
    query PurchaseOrderUniqueIdQuery($aggridInput: AnyAggridInput) {
  PurchaseOrderViewsAggrid(aggridInput: $aggridInput) {
    results {
      id
      unique_id
    }
  }
}
    `;
export const usePurchaseOrderUniqueIdQueryQuery = <
      TData = PurchaseOrderUniqueIdQueryQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: PurchaseOrderUniqueIdQueryQueryVariables,
      options?: UseQueryOptions<PurchaseOrderUniqueIdQueryQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<PurchaseOrderUniqueIdQueryQuery, TError, TData>(
      variables === undefined ? ['PurchaseOrderUniqueIdQuery'] : ['PurchaseOrderUniqueIdQuery', variables],
      fetcher<PurchaseOrderUniqueIdQueryQuery, PurchaseOrderUniqueIdQueryQueryVariables>(client, PurchaseOrderUniqueIdQueryDocument, variables, headers),
      options
    );
export const PurchaseOrderUpdateDocument = `
    mutation PurchaseOrderUpdate($uniqueInput: PurchaseOrderUniqueInput!, $input: PurchaseOrderUpdateInput!) {
  PurchaseOrderUpdate(uniqueInput: $uniqueInput, input: $input) {
    id
    unique_id
    branch_id
    branch {
      id
      unique_id
      name
      short_name
      zone
      phone
      fax
      status
      is_hq
      created_date
      last_updated_date
      address
      user_id_list
      user_list {
        id
        branch_id
        user_id
      }
    }
    reference_document_list {
      document_id
      document_unique_id
      document_type
    }
    reference_document_id
    reference_no
    created_date
    created_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    issue_date
    expected_date
    within_date
    credit_day
    currency
    currency_display_name
    exchange_rate
    destination_warehouse_id
    destination_warehouse {
      id
      branch_id
      unique_id
      name
      user_id
      description
      address
      is_same_as_branch
    }
    related_user_list
    vendor_unique_id
    vendor_details
    delivery_address
    price_vat_type
    pre_vat_amount
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    template_remark_id
    remark
    main_status
    sub_status
    flag_status
    aggrid_status
    tag_id_list
    tag_list {
      id
      name
      document_type
    }
    item_list {
      id
      unique_id
      reference_unique_id
      reference_document_type
      reference_line_item {
        line_item_unique_id
        line_item_document_type
        line_item_document_unique_id
      }
      item_unique_id
      item_sku_name
      item_name
      item_sku_desc
      item_img_url
      tracability
      barcode
      qty
      po_qty
      qty_ordered
      qty_received
      qty_issued
      uom_id
      uom_name
      price_per_unit
      discount
      vat_percentage
      pre_vat_amount
      stock_qty
      withholding_tax_type
      withholding_tax_value
      remark
    }
    approval_step
    approver_list
    reviewer_list
  }
}
    `;
export const usePurchaseOrderUpdateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<PurchaseOrderUpdateMutation, TError, PurchaseOrderUpdateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<PurchaseOrderUpdateMutation, TError, PurchaseOrderUpdateMutationVariables, TContext>(
      ['PurchaseOrderUpdate'],
      (variables?: PurchaseOrderUpdateMutationVariables) => fetcher<PurchaseOrderUpdateMutation, PurchaseOrderUpdateMutationVariables>(client, PurchaseOrderUpdateDocument, variables, headers)(),
      options
    );
export const PurchaseRequestCreateDocument = `
    mutation PurchaseRequestCreate($input: PurchaseRequestCreateInput!) {
  PurchaseRequestCreate(input: $input) {
    id
    unique_id
    branch_id
    branch {
      id
      unique_id
      name
      short_name
      zone
      phone
      fax
      status
      is_hq
      created_date
      last_updated_date
      address
      user_id_list
      user_list {
        id
        branch_id
        user_id
        user {
          id
          unique_id
          email
          original_branch
          original_branch_object {
            id
            unique_id
            name
          }
          img_url
          title_name
          first_name
          last_name
          nick_name
          gender
          phone
          department
          position
          employee_type
          company_name
          is_sales_employee
          status
          inactive_date
          start_date
          created_date
          last_updated_date
          last_login_branch
          remark_status
        }
      }
    }
    reference_document_list {
      document_id
      document_unique_id
      document_type
    }
    reference_no
    created_date
    created_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    issue_date
    expected_date
    within_date
    related_user_list
    requester
    delivery_address
    template_remark_id
    remark
    accepted_remark
    main_status
    sub_status
    flag_status
    aggrid_status
    tag_id_list
    tag_list {
      id
      name
      document_type
    }
    item_list {
      id
      unique_id
      reference_unique_id
      reference_document_type
      reference_line_item {
        line_item_unique_id
        line_item_document_type
        line_item_document_unique_id
      }
      item_unique_id
      item_sku_name
      item_name
      item_sku_desc
      item_img_url
      tracability
      barcode
      qty
      po_qty
      qty_ordered
      qty_received
      qty_issued
      uom_id
      uom_name
      price_per_unit
      discount
      vat_percentage
      pre_vat_amount
      stock_qty
      withholding_tax_type
      withholding_tax_value
      remark
    }
    attachment_list
    approval_step
    approver_list
    reviewer_list
  }
}
    `;
export const usePurchaseRequestCreateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<PurchaseRequestCreateMutation, TError, PurchaseRequestCreateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<PurchaseRequestCreateMutation, TError, PurchaseRequestCreateMutationVariables, TContext>(
      ['PurchaseRequestCreate'],
      (variables?: PurchaseRequestCreateMutationVariables) => fetcher<PurchaseRequestCreateMutation, PurchaseRequestCreateMutationVariables>(client, PurchaseRequestCreateDocument, variables, headers)(),
      options
    );
export const PurchaseRequestDeleteDocument = `
    mutation PurchaseRequestDelete($uniqueInput: PurchaseRequestUniqueInput!) {
  PurchaseRequestDelete(uniqueInput: $uniqueInput) {
    id
    unique_id
    branch_id
    branch {
      id
      unique_id
      name
      short_name
      zone
      phone
      fax
      status
      is_hq
      created_date
      last_updated_date
      address
      user_id_list
      user_list {
        id
        branch_id
        user_id
        user {
          id
          unique_id
          email
          original_branch
          original_branch_object {
            id
            unique_id
            name
          }
          img_url
          title_name
          first_name
          last_name
          nick_name
          gender
          phone
          department
          position
          employee_type
          company_name
          is_sales_employee
          status
          inactive_date
          start_date
          created_date
          last_updated_date
          last_login_branch
          remark_status
        }
      }
    }
    reference_document_list {
      document_id
      document_unique_id
      document_type
    }
    reference_no
    created_date
    created_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    issue_date
    expected_date
    within_date
    related_user_list
    requester
    delivery_address
    template_remark_id
    remark
    accepted_remark
    main_status
    sub_status
    flag_status
    aggrid_status
    tag_id_list
    tag_list {
      id
      name
      document_type
    }
    item_list {
      id
      unique_id
      reference_unique_id
      reference_document_type
      reference_line_item {
        line_item_unique_id
        line_item_document_type
        line_item_document_unique_id
      }
      item_unique_id
      item_sku_name
      item_name
      item_sku_desc
      item_img_url
      tracability
      barcode
      qty
      po_qty
      qty_ordered
      qty_received
      qty_issued
      uom_id
      uom_name
      price_per_unit
      discount
      vat_percentage
      pre_vat_amount
      stock_qty
      withholding_tax_type
      withholding_tax_value
      remark
    }
    attachment_list
    approval_step
    approver_list
    reviewer_list
  }
}
    `;
export const usePurchaseRequestDeleteMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<PurchaseRequestDeleteMutation, TError, PurchaseRequestDeleteMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<PurchaseRequestDeleteMutation, TError, PurchaseRequestDeleteMutationVariables, TContext>(
      ['PurchaseRequestDelete'],
      (variables?: PurchaseRequestDeleteMutationVariables) => fetcher<PurchaseRequestDeleteMutation, PurchaseRequestDeleteMutationVariables>(client, PurchaseRequestDeleteDocument, variables, headers)(),
      options
    );
export const PurchaseRequestFindUniqueDocument = `
    query PurchaseRequestFindUnique($uniqueInput: PurchaseRequestUniqueInput!) {
  PurchaseRequestFindUnique(uniqueInput: $uniqueInput) {
    id
    unique_id
    branch_id
    branch {
      id
      unique_id
      name
      short_name
      zone
      phone
      fax
      status
      is_hq
      created_date
      last_updated_date
      address
      user_id_list
      user_list {
        id
        branch_id
        user_id
        user {
          id
          unique_id
          email
          original_branch
          original_branch_object {
            id
            unique_id
            name
          }
          img_url
          title_name
          first_name
          last_name
          nick_name
          gender
          phone
          department
          position
          employee_type
          company_name
          is_sales_employee
          status
          inactive_date
          start_date
          created_date
          last_updated_date
          last_login_branch
          remark_status
        }
      }
    }
    reference_document_list {
      document_id
      document_unique_id
      document_type
    }
    reference_no
    created_date
    created_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    issue_date
    expected_date
    within_date
    related_user_list
    requester
    delivery_address
    template_remark_id
    remark
    accepted_remark
    main_status
    sub_status
    flag_status
    aggrid_status
    tag_id_list
    tag_list {
      id
      name
      document_type
    }
    item_list {
      id
      unique_id
      reference_unique_id
      reference_document_type
      reference_line_item {
        line_item_unique_id
        line_item_document_type
        line_item_document_unique_id
      }
      item_unique_id
      item_sku_name
      item_name
      item_sku_desc
      item_img_url
      tracability
      barcode
      qty
      po_qty
      qty_ordered
      qty_received
      qty_issued
      uom_id
      uom_name
      price_per_unit
      discount
      vat_percentage
      pre_vat_amount
      stock_qty
      withholding_tax_type
      withholding_tax_value
      remark
    }
    attachment_list
    approval_step
    approver_list
    reviewer_list
  }
}
    `;
export const usePurchaseRequestFindUniqueQuery = <
      TData = PurchaseRequestFindUniqueQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: PurchaseRequestFindUniqueQueryVariables,
      options?: UseQueryOptions<PurchaseRequestFindUniqueQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<PurchaseRequestFindUniqueQuery, TError, TData>(
      ['PurchaseRequestFindUnique', variables],
      fetcher<PurchaseRequestFindUniqueQuery, PurchaseRequestFindUniqueQueryVariables>(client, PurchaseRequestFindUniqueDocument, variables, headers),
      options
    );
export const PurchaseRequestUpdateDocument = `
    mutation PurchaseRequestUpdate($uniqueInput: PurchaseRequestUniqueInput!, $input: PurchaseRequestUpdateInput!) {
  PurchaseRequestUpdate(uniqueInput: $uniqueInput, input: $input) {
    id
    unique_id
    branch_id
    branch {
      id
      unique_id
      name
      short_name
      zone
      phone
      fax
      status
      is_hq
      created_date
      last_updated_date
      address
      user_id_list
      user_list {
        id
        branch_id
        user_id
        user {
          id
          unique_id
          email
          original_branch
          original_branch_object {
            id
            unique_id
            name
          }
          img_url
          title_name
          first_name
          last_name
          nick_name
          gender
          phone
          department
          position
          employee_type
          company_name
          is_sales_employee
          status
          inactive_date
          start_date
          created_date
          last_updated_date
          last_login_branch
          remark_status
        }
      }
    }
    reference_document_list {
      document_id
      document_unique_id
      document_type
    }
    reference_no
    created_date
    created_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    issue_date
    expected_date
    within_date
    related_user_list
    requester
    delivery_address
    template_remark_id
    remark
    accepted_remark
    main_status
    sub_status
    flag_status
    aggrid_status
    tag_id_list
    tag_list {
      id
      name
      document_type
    }
    item_list {
      id
      unique_id
      reference_unique_id
      reference_document_type
      reference_line_item {
        line_item_unique_id
        line_item_document_type
        line_item_document_unique_id
      }
      item_unique_id
      item_sku_name
      item_name
      item_sku_desc
      item_img_url
      tracability
      barcode
      qty
      po_qty
      qty_ordered
      qty_received
      qty_issued
      uom_id
      uom_name
      price_per_unit
      discount
      vat_percentage
      pre_vat_amount
      stock_qty
      withholding_tax_type
      withholding_tax_value
      remark
    }
    attachment_list
    approval_step
    approver_list
    reviewer_list
  }
}
    `;
export const usePurchaseRequestUpdateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<PurchaseRequestUpdateMutation, TError, PurchaseRequestUpdateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<PurchaseRequestUpdateMutation, TError, PurchaseRequestUpdateMutationVariables, TContext>(
      ['PurchaseRequestUpdate'],
      (variables?: PurchaseRequestUpdateMutationVariables) => fetcher<PurchaseRequestUpdateMutation, PurchaseRequestUpdateMutationVariables>(client, PurchaseRequestUpdateDocument, variables, headers)(),
      options
    );
export const PurchaseRequestsFindAllDocument = `
    query PurchaseRequestsFindAll {
  PurchaseRequestsFindAll {
    id
    unique_id
    branch_id
    branch {
      id
      unique_id
      name
      short_name
      zone
      phone
      fax
      status
      is_hq
      created_date
      last_updated_date
      address
      user_id_list
      user_list {
        id
        branch_id
        user_id
        user {
          id
          unique_id
          email
          original_branch
          original_branch_object {
            id
            unique_id
            name
          }
          img_url
          title_name
          first_name
          last_name
          nick_name
          gender
          phone
          department
          position
          employee_type
          company_name
          is_sales_employee
          status
          inactive_date
          start_date
          created_date
          last_updated_date
          last_login_branch
          remark_status
        }
      }
    }
    reference_document_list {
      document_id
      document_unique_id
      document_type
    }
    reference_no
    created_date
    created_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    issue_date
    expected_date
    within_date
    related_user_list
    requester
    delivery_address
    template_remark_id
    remark
    accepted_remark
    main_status
    sub_status
    flag_status
    aggrid_status
    tag_id_list
    tag_list {
      id
      name
      document_type
    }
    item_list {
      id
      unique_id
      reference_unique_id
      reference_document_type
      reference_line_item {
        line_item_unique_id
        line_item_document_type
        line_item_document_unique_id
      }
      item_unique_id
      item_sku_name
      item_name
      item_sku_desc
      item_img_url
      tracability
      barcode
      qty
      po_qty
      qty_ordered
      qty_received
      qty_issued
      uom_id
      uom_name
      price_per_unit
      discount
      vat_percentage
      pre_vat_amount
      stock_qty
      withholding_tax_type
      withholding_tax_value
      remark
    }
    attachment_list
    approval_step
    approver_list
    reviewer_list
  }
}
    `;
export const usePurchaseRequestsFindAllQuery = <
      TData = PurchaseRequestsFindAllQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: PurchaseRequestsFindAllQueryVariables,
      options?: UseQueryOptions<PurchaseRequestsFindAllQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<PurchaseRequestsFindAllQuery, TError, TData>(
      variables === undefined ? ['PurchaseRequestsFindAll'] : ['PurchaseRequestsFindAll', variables],
      fetcher<PurchaseRequestsFindAllQuery, PurchaseRequestsFindAllQueryVariables>(client, PurchaseRequestsFindAllDocument, variables, headers),
      options
    );
export const PurchaseReturnCreateDocument = `
    mutation PurchaseReturnCreate($input: PurchaseReturnCreateInput!) {
  PurchaseReturnCreate(input: $input) {
    id
    unique_id
    branch_id
    branch {
      id
      unique_id
      name
      short_name
      zone
      phone
      fax
      status
      is_hq
      created_date
      last_updated_date
      address
      user_id_list
      user_list {
        id
        branch_id
        user_id
      }
    }
    reference_document_list {
      document_id
      document_unique_id
      document_type
    }
    reference_no
    created_date
    created_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    issue_date
    delivery_date
    credit_day
    related_user_list
    reason_to_return
    vendor_unique_id
    vendor_details
    price_vat_type
    currency
    currency_display_name
    item_list {
      id
      unique_id
      reference_unique_id
      reference_document_type
      reference_line_item {
        line_item_unique_id
        line_item_document_type
        line_item_document_unique_id
      }
      item_unique_id
      item_sku_name
      item_name
      item_sku_desc
      item_img_url
      tracability
      barcode
      qty
      po_qty
      qty_ordered
      qty_received
      qty_issued
      uom_id
      uom_name
      price_per_unit
      discount
      vat_percentage
      pre_vat_amount
      stock_qty
      withholding_tax_type
      withholding_tax_value
      remark
    }
    pre_vat_amount
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    template_remark_id
    remark
    main_status
    sub_status
    flag_status
    aggrid_status
    tag_id_list
    tag_list {
      id
      name
      document_type
    }
    approval_step
    approver_list
    reviewer_list
  }
}
    `;
export const usePurchaseReturnCreateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<PurchaseReturnCreateMutation, TError, PurchaseReturnCreateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<PurchaseReturnCreateMutation, TError, PurchaseReturnCreateMutationVariables, TContext>(
      ['PurchaseReturnCreate'],
      (variables?: PurchaseReturnCreateMutationVariables) => fetcher<PurchaseReturnCreateMutation, PurchaseReturnCreateMutationVariables>(client, PurchaseReturnCreateDocument, variables, headers)(),
      options
    );
export const PurchaseReturnFindUniqueDocument = `
    query PurchaseReturnFindUnique($uniqueInput: PurchaseReturnUniqueInput!) {
  PurchaseReturnFindUnique(uniqueInput: $uniqueInput) {
    id
    unique_id
    branch_id
    branch {
      id
      unique_id
      name
      short_name
      zone
      phone
      fax
      status
      is_hq
      created_date
      last_updated_date
      address
      user_id_list
      user_list {
        id
        branch_id
        user_id
      }
    }
    reference_document_list {
      document_id
      document_unique_id
      document_type
    }
    reference_no
    created_date
    created_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    issue_date
    delivery_date
    credit_day
    related_user_list
    reason_to_return
    vendor_unique_id
    vendor_details
    price_vat_type
    currency
    currency_display_name
    item_list {
      id
      unique_id
      reference_unique_id
      reference_document_type
      reference_line_item {
        line_item_unique_id
        line_item_document_type
        line_item_document_unique_id
      }
      item_unique_id
      item_sku_name
      item_name
      item_sku_desc
      item_img_url
      tracability
      barcode
      qty
      po_qty
      qty_ordered
      qty_received
      qty_issued
      uom_id
      uom_name
      price_per_unit
      discount
      vat_percentage
      pre_vat_amount
      stock_qty
      withholding_tax_type
      withholding_tax_value
      remark
    }
    pre_vat_amount
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    template_remark_id
    remark
    main_status
    sub_status
    flag_status
    aggrid_status
    tag_id_list
    tag_list {
      id
      name
      document_type
    }
    approval_step
    approver_list
    reviewer_list
  }
}
    `;
export const usePurchaseReturnFindUniqueQuery = <
      TData = PurchaseReturnFindUniqueQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: PurchaseReturnFindUniqueQueryVariables,
      options?: UseQueryOptions<PurchaseReturnFindUniqueQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<PurchaseReturnFindUniqueQuery, TError, TData>(
      ['PurchaseReturnFindUnique', variables],
      fetcher<PurchaseReturnFindUniqueQuery, PurchaseReturnFindUniqueQueryVariables>(client, PurchaseReturnFindUniqueDocument, variables, headers),
      options
    );
export const PurchaseReturnUniqueIdQueryDocument = `
    query PurchaseReturnUniqueIdQuery($aggridInput: AnyAggridInput) {
  PurchaseReturnViewsAggrid(aggridInput: $aggridInput) {
    results {
      id
      unique_id
      item_list {
        qty
        qty_issued
      }
    }
  }
}
    `;
export const usePurchaseReturnUniqueIdQueryQuery = <
      TData = PurchaseReturnUniqueIdQueryQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: PurchaseReturnUniqueIdQueryQueryVariables,
      options?: UseQueryOptions<PurchaseReturnUniqueIdQueryQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<PurchaseReturnUniqueIdQueryQuery, TError, TData>(
      variables === undefined ? ['PurchaseReturnUniqueIdQuery'] : ['PurchaseReturnUniqueIdQuery', variables],
      fetcher<PurchaseReturnUniqueIdQueryQuery, PurchaseReturnUniqueIdQueryQueryVariables>(client, PurchaseReturnUniqueIdQueryDocument, variables, headers),
      options
    );
export const PurchaseReturnUpdateDocument = `
    mutation PurchaseReturnUpdate($uniqueInput: PurchaseReturnUniqueInput!, $input: PurchaseReturnUpdateInput!) {
  PurchaseReturnUpdate(uniqueInput: $uniqueInput, input: $input) {
    id
    unique_id
    branch_id
    branch {
      id
      unique_id
      name
      short_name
      zone
      phone
      fax
      status
      is_hq
      created_date
      last_updated_date
      address
      user_id_list
      user_list {
        id
        branch_id
        user_id
      }
    }
    reference_document_list {
      document_id
      document_unique_id
      document_type
    }
    reference_no
    created_date
    created_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    last_updated_date
    last_updated_by {
      user_id
      user_unique_id
      first_name
      last_name
      email
      img_url
    }
    issue_date
    delivery_date
    credit_day
    related_user_list
    reason_to_return
    vendor_unique_id
    vendor_details
    price_vat_type
    currency
    currency_display_name
    item_list {
      id
      unique_id
      reference_unique_id
      reference_document_type
      reference_line_item {
        line_item_unique_id
        line_item_document_type
        line_item_document_unique_id
      }
      item_unique_id
      item_sku_name
      item_name
      item_sku_desc
      item_img_url
      tracability
      barcode
      qty
      po_qty
      qty_ordered
      qty_received
      qty_issued
      uom_id
      uom_name
      price_per_unit
      discount
      vat_percentage
      pre_vat_amount
      stock_qty
      withholding_tax_type
      withholding_tax_value
      remark
    }
    pre_vat_amount
    additional_discount
    additional_discount_type
    post_discount_amount
    vat_exempted_amount
    vat_0_percent_amount
    vat_7_percent_amount
    vat_amount
    net_amount
    withholding_tax_amount
    total_amount
    template_remark_id
    remark
    main_status
    sub_status
    flag_status
    aggrid_status
    tag_id_list
    tag_list {
      id
      name
      document_type
    }
    approval_step
    approver_list
    reviewer_list
  }
}
    `;
export const usePurchaseReturnUpdateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<PurchaseReturnUpdateMutation, TError, PurchaseReturnUpdateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<PurchaseReturnUpdateMutation, TError, PurchaseReturnUpdateMutationVariables, TContext>(
      ['PurchaseReturnUpdate'],
      (variables?: PurchaseReturnUpdateMutationVariables) => fetcher<PurchaseReturnUpdateMutation, PurchaseReturnUpdateMutationVariables>(client, PurchaseReturnUpdateDocument, variables, headers)(),
      options
    );
export const PurchaseUniqueIdGenerateDocument = `
    query PurchaseUniqueIdGenerate($modelType: PurchaseModelType!) {
  UniqueIdGenerate(modelType: $modelType)
}
    `;
export const usePurchaseUniqueIdGenerateQuery = <
      TData = PurchaseUniqueIdGenerateQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: PurchaseUniqueIdGenerateQueryVariables,
      options?: UseQueryOptions<PurchaseUniqueIdGenerateQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<PurchaseUniqueIdGenerateQuery, TError, TData>(
      ['PurchaseUniqueIdGenerate', variables],
      fetcher<PurchaseUniqueIdGenerateQuery, PurchaseUniqueIdGenerateQueryVariables>(client, PurchaseUniqueIdGenerateDocument, variables, headers),
      options
    );